var _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationPairProgramming(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-5",
    d: "M413.69,260.85c-90.45-52-237.11-52-327.56,0s-90.45,136.34,0,188.35,237.11,52,327.56,0S504.14,312.86,413.69,260.85Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-5",
    d: "M243.76,469.54,154.67,418.1a1.32,1.32,0,0,1,0-2.5l174.4-100.69a4.79,4.79,0,0,1,4.33,0l89.09,51.44a1.32,1.32,0,0,1,0,2.5L248.09,469.54A4.79,4.79,0,0,1,243.76,469.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M124.87,377.44c-7.17-4.14-7.17-10.86,0-15L168,337.57c7.17-4.14,18.8-4.14,26,0L246,367.64l-69.13,39.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M457,342.64c8.92,5.21,8.92,13.66,0,18.87s-23.39,5.21-32.32,0-8.92-13.66,0-18.87S448.12,337.43,457,342.64Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.43,24.09a1.34,1.34,0,0,0-.07-.4s0-.06,0-.08a2,2,0,0,0-.1-.39,1.85,1.85,0,0,0-.26-.55.68.68,0,0,0-.14-.23.65.65,0,0,0-.13-.16,1.24,1.24,0,0,0-.28-.28l0,0a1.36,1.36,0,0,0-.37-.21,3.16,3.16,0,0,0-2.92.37L49.1,131.48A9.6,9.6,0,0,0,44.76,139V303.17a2.94,2.94,0,0,0,1.56,2.61l.19.12a1.26,1.26,0,0,0,.23.13,1.47,1.47,0,0,0,.37.13,2.59,2.59,0,0,0,.55.07,2.78,2.78,0,0,0,1.44-.41l.11-.07h0l4.14-2.39,185.76-107a9.57,9.57,0,0,0,4.34-7.51V24.63A4.75,4.75,0,0,0,243.43,24.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,21.76a3.16,3.16,0,0,0-2.92.37L49.1,131.48A9.6,9.6,0,0,0,44.76,139v6.34l-5.53-3.24v-6.24a9.57,9.57,0,0,1,4.32-7.5L233.59,19a3,3,0,0,1,3.14-.26C237.52,19.21,241.11,21.27,242,21.76Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.45,24.6c0-2.74-1.95-3.84-4.33-2.47L49.1,131.48A9.59,9.59,0,0,0,44.76,139v6.35L243.45,31Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.12,22.13,49.1,131.48a8.94,8.94,0,0,0-3.05,3.22l-5.51-3.19a8.52,8.52,0,0,1,3-3.16L233.59,19a3,3,0,0,1,3.14-.25c.78.47,4.38,2.52,5.29,3A3.12,3.12,0,0,0,239.12,22.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.22,142.11v-6.27a9,9,0,0,1,1.32-4.33l5.52,3.18a8.78,8.78,0,0,0-1.29,4.3v6.35Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.32,305.8l-.23-.13L41.52,303a4.62,4.62,0,0,1-2.26-3.36,4.44,4.44,0,0,1,0-.63v-157l5.54,3.25V303.17a2.85,2.85,0,0,0,1.35,2.46,1.21,1.21,0,0,0,.14.1s0,0,0,0Z",
    style: {
      fill: "#263238",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-5",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.6,139.17l39.77-22.94c.6-.35,1.08-.1,1.08.54a2.34,2.34,0,0,1-1.08,1.81l-39.76,23c-.6.34-1.09.1-1.09-.55A2.37,2.37,0,0,1,75.6,139.17Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.34,157.42l77.15-44.59c.6-.34,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-77.15,44.6c-.6.34-1.09.1-1.09-.55A2.35,2.35,0,0,1,93.34,157.42Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.57,113.8l51.58-29.71c.6-.34,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-51.58,29.71c-.59.34-1.08.1-1.08-.55A2.33,2.33,0,0,1,119.57,113.8Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6,145.93l18.6-10.74c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8L75.61,148.28c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,75.6,145.93Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6,145.93l18.6-10.74c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8L75.61,148.28c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,75.6,145.93Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6,152.65l9.93-5.71c.6-.34,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.81L75.61,155c-.6.34-1.09.1-1.09-.55A2.33,2.33,0,0,1,75.6,152.65Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6,152.65l9.93-5.71c.6-.34,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.81L75.61,155c-.6.34-1.09.1-1.09-.55A2.33,2.33,0,0,1,75.6,152.65Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.41,132.76l47.4-27.34c.6-.35,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-47.4,27.34c-.6.35-1.08.1-1.08-.55A2.31,2.31,0,0,1,98.41,132.76Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.41,132.76l47.4-27.34c.6-.35,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8l-47.4,27.34c-.6.35-1.08.1-1.08-.55A2.31,2.31,0,0,1,98.41,132.76Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.72,165.19l49.43-28.56c.6-.34,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.81l-49.43,28.55c-.6.35-1.08.1-1.08-.54A2.34,2.34,0,0,1,121.72,165.19Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.72,158.48l49.43-28.59c.6-.35,1.09-.1,1.09.54a2.35,2.35,0,0,1-1.09,1.81l-49.43,28.59c-.6.35-1.08.1-1.08-.55A2.32,2.32,0,0,1,121.72,158.48Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,145,110.5,132.5c.6-.35,1.08-.1,1.08.55a2.34,2.34,0,0,1-1.08,1.8L89,147.31c-.6.34-1.09.1-1.09-.55A2.32,2.32,0,0,1,89,145Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,145,110.5,132.5c.6-.35,1.08-.1,1.08.55a2.34,2.34,0,0,1-1.08,1.8L89,147.31c-.6.34-1.09.1-1.09-.55A2.32,2.32,0,0,1,89,145Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.71,130.07l55.8-31.92c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-55.8,31.92c-.6.34-1.09.1-1.09-.55A2.32,2.32,0,0,1,114.71,130.07Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.71,130.07l55.8-31.92c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-55.8,31.92c-.6.34-1.09.1-1.09-.55A2.32,2.32,0,0,1,114.71,130.07Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,152.17l21.48-12.46c.6-.35,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L89,154.52c-.6.34-1.09.1-1.09-.55A2.32,2.32,0,0,1,89,152.17Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,152.17l21.48-12.46c.6-.35,1.08-.1,1.08.55a2.32,2.32,0,0,1-1.08,1.8L89,154.52c-.6.34-1.09.1-1.09-.55A2.32,2.32,0,0,1,89,152.17Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.71,137.28l55.8-31.92c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-55.8,31.92c-.6.34-1.09.1-1.09-.55A2.32,2.32,0,0,1,114.71,137.28Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.71,137.28l55.8-31.92c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-55.8,31.92c-.6.34-1.09.1-1.09-.55A2.32,2.32,0,0,1,114.71,137.28Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.72,172l49.43-28.39c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-49.43,28.39c-.6.35-1.08.11-1.08-.54A2.34,2.34,0,0,1,121.72,172Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.72,178.72l49.43-28.39c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-49.43,28.4c-.6.34-1.08.1-1.08-.55A2.34,2.34,0,0,1,121.72,178.72Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.72,185.45l49.43-28.39c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-49.43,28.4c-.6.34-1.08.1-1.08-.55A2.34,2.34,0,0,1,121.72,185.45Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.72,194.39,171.15,166c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-49.43,28.38c-.6.35-1.08.1-1.08-.55A2.31,2.31,0,0,1,121.72,194.39Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,222.7l10-5.81c.6-.34,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.35,2.35,0,0,1,72.72,222.7Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,222.7l10-5.81c.6-.34,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.35,2.35,0,0,1,72.72,222.7Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,228.79l10-5.81c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-10,5.81c-.59.34-1.08.1-1.08-.55A2.33,2.33,0,0,1,72.72,228.79Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,228.79l10-5.81c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-10,5.81c-.59.34-1.08.1-1.08-.55A2.33,2.33,0,0,1,72.72,228.79Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.72,200.52l49.43-28.6c.6-.34,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-49.43,28.6c-.6.35-1.08.1-1.08-.55A2.31,2.31,0,0,1,121.72,200.52Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.37,263.28l26-15c.6-.34,1.08-.1,1.08.55a2.34,2.34,0,0,1-1.08,1.81l-26,15c-.6.35-1.08.1-1.08-.55A2.32,2.32,0,0,1,89.37,263.28Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.57,245.79l51.58-29.64c.6-.34,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.81l-51.58,29.64c-.59.34-1.08.1-1.08-.55A2.37,2.37,0,0,1,119.57,245.79Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,272.85l10-5.81c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-10,5.81c-.59.34-1.08.1-1.08-.55A2.33,2.33,0,0,1,72.72,272.85Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,272.85l10-5.81c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-10,5.81c-.59.34-1.08.1-1.08-.55A2.33,2.33,0,0,1,72.72,272.85Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,278.93l10-5.81c.6-.34,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.35,2.35,0,0,1,72.72,278.93Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,278.93l10-5.81c.6-.34,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.35,2.35,0,0,1,72.72,278.93Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.76,249.41l47.39-27.34c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-47.39,27.34c-.6.35-1.09.1-1.09-.55A2.32,2.32,0,0,1,123.76,249.41Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,233.91l82.13-47.3c.6-.34,1.09-.1,1.09.55a2.35,2.35,0,0,1-1.09,1.81L89,236.27c-.6.34-1.09.1-1.09-.55A2.35,2.35,0,0,1,89,233.91Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,243.26l10-5.81c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.33,2.33,0,0,1,72.72,243.26Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,243.26l10-5.81c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.33,2.33,0,0,1,72.72,243.26Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,240.56l82.13-47.3c.6-.34,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8L89,242.91c-.6.35-1.09.1-1.09-.55A2.35,2.35,0,0,1,89,240.56Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,250l10-5.81c.6-.35,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.33,2.33,0,0,1,72.72,250Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,250l10-5.81c.6-.35,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.33,2.33,0,0,1,72.72,250Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,247.32,171.15,200c.6-.34,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8L89,249.67c-.6.35-1.09.1-1.09-.55A2.33,2.33,0,0,1,89,247.32Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,256.72l10-5.81c.6-.35,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.35,2.35,0,0,1,72.72,256.72Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,256.72l10-5.81c.6-.35,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.35,2.35,0,0,1,72.72,256.72Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.06,236.67,63,233.26c.59-.34,1.07-.06,1.07.62v2.17A2.37,2.37,0,0,1,63,237.91l-5.91,3.41c-.59.34-1.07.07-1.07-.62v-2.17A2.38,2.38,0,0,1,57.06,236.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,245.31,63,241.9c.59-.34,1.07-.06,1.07.62v2.17A2.37,2.37,0,0,1,63,246.55L57.06,250c-.59.34-1.07.07-1.07-.62v-2.17A2.4,2.4,0,0,1,57.06,245.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,254,63,250.54c.59-.34,1.07-.06,1.07.62v2.17A2.37,2.37,0,0,1,63,255.19l-5.91,3.41c-.59.34-1.07.07-1.07-.62v-2.17A2.4,2.4,0,0,1,57.06,254Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,262.59,63,259.18c.59-.34,1.07-.06,1.07.62V262A2.37,2.37,0,0,1,63,263.83l-5.91,3.41c-.59.34-1.07.07-1.07-.62v-2.17A2.4,2.4,0,0,1,57.06,262.59Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,185.93l10-5.81c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-10,5.81c-.59.34-1.08.1-1.08-.55A2.33,2.33,0,0,1,72.72,185.93Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,185.93l10-5.81c.6-.35,1.09-.1,1.09.55a2.33,2.33,0,0,1-1.09,1.8l-10,5.81c-.59.34-1.08.1-1.08-.55A2.33,2.33,0,0,1,72.72,185.93Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,200.4l10-5.81c.6-.35,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.33,2.33,0,0,1,72.72,200.4Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,200.4l10-5.81c.6-.35,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.33,2.33,0,0,1,72.72,200.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,207.13l10-5.81c.6-.35,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.33,2.33,0,0,1,72.72,207.13Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,207.13l10-5.81c.6-.35,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.33,2.33,0,0,1,72.72,207.13Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,213.86l10-5.81c.6-.35,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.35,2.35,0,0,1,72.72,213.86Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.72,213.86l10-5.81c.6-.35,1.09-.1,1.09.55a2.32,2.32,0,0,1-1.09,1.8l-10,5.81c-.59.35-1.08.1-1.08-.55A2.35,2.35,0,0,1,72.72,213.86Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.06,193.81,63,190.4c.59-.34,1.07-.06,1.07.62v2.17A2.37,2.37,0,0,1,63,195.05l-5.91,3.41c-.59.34-1.07.07-1.07-.62v-2.17A2.4,2.4,0,0,1,57.06,193.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,202.45,63,199c.59-.34,1.07-.06,1.07.62v2.17A2.37,2.37,0,0,1,63,203.69l-5.91,3.41c-.59.34-1.07.07-1.07-.62v-2.17A2.4,2.4,0,0,1,57.06,202.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,211.09,63,207.68c.59-.34,1.07-.06,1.07.62v2.17A2.37,2.37,0,0,1,63,212.33l-5.91,3.41c-.59.34-1.07.07-1.07-.62V213A2.4,2.4,0,0,1,57.06,211.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,219.73,63,216.32c.59-.34,1.07-.06,1.07.62v2.17A2.37,2.37,0,0,1,63,221l-5.91,3.41c-.59.34-1.07.07-1.07-.62v-2.17A2.4,2.4,0,0,1,57.06,219.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,279.53,63,276.12c.59-.34,1.07-.06,1.07.62v2.17A2.37,2.37,0,0,1,63,280.77l-5.91,3.41c-.59.34-1.07.07-1.07-.62v-2.17A2.38,2.38,0,0,1,57.06,279.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,288.17,63,284.76c.59-.34,1.07-.06,1.07.62v2.17A2.37,2.37,0,0,1,63,289.41l-5.91,3.41c-.59.34-1.07.07-1.07-.62V290A2.4,2.4,0,0,1,57.06,288.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.06,151,63,147.54c.59-.34,1.07-.06,1.07.62v2.17A2.37,2.37,0,0,1,63,152.19l-5.91,3.41c-.59.34-1.07.07-1.07-.62v-2.17A2.4,2.4,0,0,1,57.06,151Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,159.59,63,156.18c.59-.34,1.07-.06,1.07.62V159A2.37,2.37,0,0,1,63,160.83l-5.91,3.41c-.59.34-1.07.07-1.07-.62v-2.17A2.4,2.4,0,0,1,57.06,159.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,168.23,63,164.82c.59-.34,1.07-.06,1.07.62v2.17A2.37,2.37,0,0,1,63,169.47l-5.91,3.41c-.59.34-1.07.07-1.07-.62v-2.17A2.4,2.4,0,0,1,57.06,168.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.06,176.87,63,173.46c.59-.34,1.07-.06,1.07.62v2.17A2.37,2.37,0,0,1,63,178.11l-5.91,3.41c-.59.34-1.07.07-1.07-.62v-2.17A2.4,2.4,0,0,1,57.06,176.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.59,114.47l-45.31,26.17a6.73,6.73,0,0,0-3.05,5.27v68.24c0,1.94,1.37,2.73,3.05,1.76l45.31-26.16a6.72,6.72,0,0,0,3-5.27V116.23C233.63,114.29,232.27,113.5,230.59,114.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,166.34l-4.17,2.41a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.42a3.29,3.29,0,0,0,1.54-2.55C227.92,166.2,227.23,165.85,226.38,166.34Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,166.34l-4.17,2.41a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.42a3.29,3.29,0,0,0,1.54-2.55C227.92,166.2,227.23,165.85,226.38,166.34Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,123.49l-4.17,2.41a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.41a3.31,3.31,0,0,0,1.54-2.56C227.92,123.35,227.23,123,226.38,123.49Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,123.49l-4.17,2.41a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.41a3.31,3.31,0,0,0,1.54-2.56C227.92,123.35,227.23,123,226.38,123.49Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,135.43l-4.17,2.41a3.29,3.29,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.42a3.29,3.29,0,0,0,1.54-2.55C222.06,135.28,221.37,134.94,220.52,135.43Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,135.43l-4.17,2.41a3.29,3.29,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.42a3.29,3.29,0,0,0,1.54-2.55C222.06,135.28,221.37,134.94,220.52,135.43Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,144l-4.17,2.42a3.29,3.29,0,0,0-1.54,2.55c0,.92.69,1.27,1.54.78l4.17-2.41a3.31,3.31,0,0,0,1.54-2.56C222.06,143.83,221.37,143.48,220.52,144Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,144l-4.17,2.42a3.29,3.29,0,0,0-1.54,2.55c0,.92.69,1.27,1.54.78l4.17-2.41a3.31,3.31,0,0,0,1.54-2.56C222.06,143.83,221.37,143.48,220.52,144Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,149.19l-4.17,2.42a3.29,3.29,0,0,0-1.54,2.55c0,.92.69,1.27,1.54.78l4.17-2.41a3.31,3.31,0,0,0,1.54-2.56C227.92,149.05,227.23,148.7,226.38,149.19Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,149.19l-4.17,2.42a3.29,3.29,0,0,0-1.54,2.55c0,.92.69,1.27,1.54.78l4.17-2.41a3.31,3.31,0,0,0,1.54-2.56C227.92,149.05,227.23,148.7,226.38,149.19Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,161.14l-4.17,2.41a3.29,3.29,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.42a3.29,3.29,0,0,0,1.54-2.55C222.06,161,221.37,160.65,220.52,161.14Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,161.14l-4.17,2.41a3.29,3.29,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.42a3.29,3.29,0,0,0,1.54-2.55C222.06,161,221.37,160.65,220.52,161.14Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,130.09,189.49,144.8a3.29,3.29,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78L215,133.43a3.31,3.31,0,0,0,1.54-2.56C216.5,130,215.81,129.6,215,130.09Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,130.09,189.49,144.8a3.29,3.29,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78L215,133.43a3.31,3.31,0,0,0,1.54-2.56C216.5,130,215.81,129.6,215,130.09Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,172.94l-25.47,14.71A3.29,3.29,0,0,0,188,190.2c0,.92.69,1.27,1.54.78L215,176.27a3.29,3.29,0,0,0,1.54-2.55C216.5,172.79,215.81,172.45,215,172.94Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,172.94l-25.47,14.71A3.29,3.29,0,0,0,188,190.2c0,.92.69,1.27,1.54.78L215,176.27a3.29,3.29,0,0,0,1.54-2.55C216.5,172.79,215.81,172.45,215,172.94Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,142l-19.61,11.35a3.29,3.29,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.77l19.61-11.34a3.31,3.31,0,0,0,1.54-2.56C210.64,141.88,210,141.53,209.1,142Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,142l-19.61,11.35a3.29,3.29,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.77l19.61-11.34a3.31,3.31,0,0,0,1.54-2.56C210.64,141.88,210,141.53,209.1,142Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,150.59l-19.61,11.35a3.29,3.29,0,0,0-1.54,2.55c0,.93.69,1.27,1.54.78l19.61-11.34a3.31,3.31,0,0,0,1.54-2.56C210.64,150.45,210,150.1,209.1,150.59Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,150.59l-19.61,11.35a3.29,3.29,0,0,0-1.54,2.55c0,.93.69,1.27,1.54.78l19.61-11.34a3.31,3.31,0,0,0,1.54-2.56C210.64,150.45,210,150.1,209.1,150.59Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,155.8l-25.47,14.71a3.29,3.29,0,0,0-1.54,2.55c0,.93.69,1.27,1.54.78L215,159.13a3.29,3.29,0,0,0,1.54-2.55C216.5,155.66,215.81,155.31,215,155.8Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,155.8l-25.47,14.71a3.29,3.29,0,0,0-1.54,2.55c0,.93.69,1.27,1.54.78L215,159.13a3.29,3.29,0,0,0,1.54-2.55C216.5,155.66,215.81,155.31,215,155.8Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,167.73l-19.61,11.35a3.29,3.29,0,0,0-1.54,2.55c0,.92.69,1.27,1.54.78l19.61-11.34a3.29,3.29,0,0,0,1.54-2.56C210.64,167.59,210,167.24,209.1,167.73Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,167.73l-19.61,11.35a3.29,3.29,0,0,0-1.54,2.55c0,.92.69,1.27,1.54.78l19.61-11.34a3.29,3.29,0,0,0,1.54-2.56C210.64,167.59,210,167.24,209.1,167.73Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,183.57,222.21,186a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.41a3.31,3.31,0,0,0,1.54-2.56C227.92,183.43,227.23,183.08,226.38,183.57Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,183.57,222.21,186a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.41a3.31,3.31,0,0,0,1.54-2.56C227.92,183.43,227.23,183.08,226.38,183.57Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,178.37l-4.17,2.41a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.42a3.29,3.29,0,0,0,1.54-2.55C222.06,178.23,221.37,177.88,220.52,178.37Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,178.37l-4.17,2.41a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.42a3.29,3.29,0,0,0,1.54-2.55C222.06,178.23,221.37,177.88,220.52,178.37Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,190.17l-25.47,14.71a3.29,3.29,0,0,0-1.54,2.55c0,.93.69,1.27,1.54.78L215,193.5A3.29,3.29,0,0,0,216.5,191C216.5,190,215.81,189.68,215,190.17Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,190.17l-25.47,14.71a3.29,3.29,0,0,0-1.54,2.55c0,.93.69,1.27,1.54.78L215,193.5A3.29,3.29,0,0,0,216.5,191C216.5,190,215.81,189.68,215,190.17Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,185l-19.61,11.34a3.29,3.29,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.77L209.1,188.3a3.29,3.29,0,0,0,1.54-2.55C210.64,184.82,210,184.48,209.1,185Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,185l-19.61,11.34a3.29,3.29,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.77L209.1,188.3a3.29,3.29,0,0,0,1.54-2.55C210.64,184.82,210,184.48,209.1,185Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.59,44.28,185.28,70.44a6.73,6.73,0,0,0-3.05,5.27V128c0,1.95,1.37,2.73,3.05,1.76l45.31-26.16a6.72,6.72,0,0,0,3-5.27V46C233.63,44.1,232.27,43.31,230.59,44.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,96.14l-4.17,2.42a3.29,3.29,0,0,0-1.54,2.55c0,.92.69,1.27,1.54.78l4.17-2.41a3.31,3.31,0,0,0,1.54-2.56C227.92,96,227.23,95.65,226.38,96.14Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,96.14l-4.17,2.42a3.29,3.29,0,0,0-1.54,2.55c0,.92.69,1.27,1.54.78l4.17-2.41a3.31,3.31,0,0,0,1.54-2.56C227.92,96,227.23,95.65,226.38,96.14Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,53.3l-4.17,2.41a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.42a3.29,3.29,0,0,0,1.54-2.55C227.92,53.16,227.23,52.81,226.38,53.3Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,53.3l-4.17,2.41a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.42a3.29,3.29,0,0,0,1.54-2.55C227.92,53.16,227.23,52.81,226.38,53.3Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,65.23l-4.17,2.42a3.29,3.29,0,0,0-1.54,2.55c0,.92.69,1.27,1.54.78l4.17-2.41A3.31,3.31,0,0,0,222.06,66C222.06,65.09,221.37,64.74,220.52,65.23Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,65.23l-4.17,2.42a3.29,3.29,0,0,0-1.54,2.55c0,.92.69,1.27,1.54.78l4.17-2.41A3.31,3.31,0,0,0,222.06,66C222.06,65.09,221.37,64.74,220.52,65.23Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,73.78l-4.17,2.41a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.41a3.31,3.31,0,0,0,1.54-2.56C222.06,73.64,221.37,73.29,220.52,73.78Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,73.78l-4.17,2.41a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.41a3.31,3.31,0,0,0,1.54-2.56C222.06,73.64,221.37,73.29,220.52,73.78Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,79l-4.17,2.41A3.31,3.31,0,0,0,220.67,84c0,.92.69,1.27,1.54.78l4.17-2.41a3.32,3.32,0,0,0,1.54-2.56C227.92,78.86,227.23,78.51,226.38,79Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.38,79l-4.17,2.41A3.31,3.31,0,0,0,220.67,84c0,.92.69,1.27,1.54.78l4.17-2.41a3.32,3.32,0,0,0,1.54-2.56C227.92,78.86,227.23,78.51,226.38,79Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,90.94l-4.17,2.41a3.32,3.32,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.41a3.31,3.31,0,0,0,1.54-2.56C222.06,90.8,221.37,90.45,220.52,90.94Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,90.94l-4.17,2.41a3.32,3.32,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l4.17-2.41a3.31,3.31,0,0,0,1.54-2.56C222.06,90.8,221.37,90.45,220.52,90.94Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,59.9,189.49,74.61A3.29,3.29,0,0,0,188,77.16c0,.92.69,1.27,1.54.78L215,63.23a3.29,3.29,0,0,0,1.54-2.55C216.5,59.75,215.81,59.41,215,59.9Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,59.9,189.49,74.61A3.29,3.29,0,0,0,188,77.16c0,.92.69,1.27,1.54.78L215,63.23a3.29,3.29,0,0,0,1.54-2.55C216.5,59.75,215.81,59.41,215,59.9Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,102.74l-25.47,14.71A3.31,3.31,0,0,0,188,120c0,.92.69,1.27,1.54.78L215,106.08a3.31,3.31,0,0,0,1.54-2.56C216.5,102.6,215.81,102.25,215,102.74Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,102.74l-25.47,14.71A3.31,3.31,0,0,0,188,120c0,.92.69,1.27,1.54.78L215,106.08a3.31,3.31,0,0,0,1.54-2.56C216.5,102.6,215.81,102.25,215,102.74Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,71.83,189.49,83.17A3.32,3.32,0,0,0,188,85.73c0,.92.69,1.27,1.54.78L209.1,75.17a3.31,3.31,0,0,0,1.54-2.56C210.64,71.69,210,71.34,209.1,71.83Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,71.83,189.49,83.17A3.32,3.32,0,0,0,188,85.73c0,.92.69,1.27,1.54.78L209.1,75.17a3.31,3.31,0,0,0,1.54-2.56C210.64,71.69,210,71.34,209.1,71.83Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,80.4,189.49,91.74A3.31,3.31,0,0,0,188,94.3c0,.92.69,1.27,1.54.78L209.1,83.74a3.32,3.32,0,0,0,1.54-2.56C210.64,80.26,210,79.91,209.1,80.4Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,80.4,189.49,91.74A3.31,3.31,0,0,0,188,94.3c0,.92.69,1.27,1.54.78L209.1,83.74a3.32,3.32,0,0,0,1.54-2.56C210.64,80.26,210,79.91,209.1,80.4Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,85.6l-25.47,14.71a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78L215,88.94a3.31,3.31,0,0,0,1.54-2.56C216.5,85.46,215.81,85.11,215,85.6Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215,85.6l-25.47,14.71a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78L215,88.94a3.31,3.31,0,0,0,1.54-2.56C216.5,85.46,215.81,85.11,215,85.6Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,97.54l-19.61,11.34a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l19.61-11.34a3.31,3.31,0,0,0,1.54-2.56C210.64,97.4,210,97.05,209.1,97.54Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1,97.54l-19.61,11.34a3.31,3.31,0,0,0-1.54,2.56c0,.92.69,1.27,1.54.78l19.61-11.34a3.31,3.31,0,0,0,1.54-2.56C210.64,97.4,210,97.05,209.1,97.54Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.18,155.37,72,176.78a3.27,3.27,0,0,0-1.49,2.57v50.83A3.24,3.24,0,0,0,72,232.73l2.83,1.6a3.33,3.33,0,0,0,3,0L115,212.91a3.26,3.26,0,0,0,1.48-2.57V159.52A3.23,3.23,0,0,0,115,157l-2.83-1.6A3.3,3.3,0,0,0,109.18,155.37Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.83,234.32a3.42,3.42,0,0,1-3,0L72,232.73a3.22,3.22,0,0,1-1.5-2.55V179.35a3.13,3.13,0,0,1,.47-1.51l5.78,3.34a3,3,0,0,0-.44,1.46v50.82C76.34,234.33,77,234.83,77.83,234.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.46,159.25c-.12-.75-.73-1-1.47-.59L77.83,180.07a3,3,0,0,0-1,1.11L71,177.84a2.89,2.89,0,0,1,1-1.06l37.16-21.41a3.33,3.33,0,0,1,3,0L115,157A3.27,3.27,0,0,1,116.46,159.25Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,158.66,77.83,180.07a3.27,3.27,0,0,0-1.49,2.57v50.82c0,.95.67,1.33,1.49.86L115,212.91a3.26,3.26,0,0,0,1.48-2.57V159.52C116.47,158.57,115.81,158.19,115,158.66Z",
    style: {
      fill: "#FF577F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.8,206.47a2.58,2.58,0,0,1,.16-.93,6,6,0,0,1,.48-.86l8.76-14.17.14-.17.1-.07a.25.25,0,0,1,.33,0,.58.58,0,0,1,.13.43v5.47a2.34,2.34,0,0,1-.25,1.14q-.25.47-.45.75L84.37,204l3.83,1.5a1.76,1.76,0,0,1,.45.21c.17.11.25.38.25.83V212a1.29,1.29,0,0,1-.13.58.82.82,0,0,1-.33.39l-.1,0a.32.32,0,0,1-.14,0l-8.76-4a1.16,1.16,0,0,1-.48-.32,1.22,1.22,0,0,1-.16-.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.91,182.44a4.13,4.13,0,0,1,.33-.88,1.59,1.59,0,0,1,.64-.69l2.93-1.69a.26.26,0,0,1,.34,0,.57.57,0,0,1,.14.44,1.47,1.47,0,0,1,0,.33l-7.41,31.57a4.68,4.68,0,0,1-.3.86,1.68,1.68,0,0,1-.66.71L91,214.77a.26.26,0,0,1-.34,0,.59.59,0,0,1-.15-.44,1.56,1.56,0,0,1,0-.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,187.55a2.49,2.49,0,0,1-.16.92,6,6,0,0,1-.48.86l-8.76,14.17a.92.92,0,0,1-.15.17l-.09.08c-.14.07-.25.07-.33,0a.57.57,0,0,1-.13-.43v-5.46a2.28,2.28,0,0,1,.25-1.13c.17-.3.32-.54.45-.73l3.83-5.93-3.83-1.46a1.6,1.6,0,0,1-.45-.23c-.17-.12-.25-.4-.25-.85V182a1.33,1.33,0,0,1,.13-.58.81.81,0,0,1,.33-.39l.09,0h.15l8.76,4.05a1.26,1.26,0,0,1,.48.32,1.24,1.24,0,0,1,.16.73Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.48,297.24h0a.69.69,0,0,0-.76.1l-1.54,1.1-.32,1a1.81,1.81,0,0,0,.51,1.74,8,8,0,0,1,.75.86,1.08,1.08,0,0,0,1.5.26l3.6-2.58a.73.73,0,0,1,.75-.11ZM61.34,311c-.64-3-2.61-4.39-5.07-4.09a8.54,8.54,0,0,1,.58,1.73c1,4.72-1.73,11.57-6.11,15.31a9.05,9.05,0,0,1-4.65,2.31c1.61,3.13,5.37,3.28,9.15.05C59.62,322.61,62.35,315.76,61.34,311Zm-.74-20.29h0a.92.92,0,0,0-.29-.11l-2.81-.52a1.52,1.52,0,0,0-1.55.8L53.53,296a2.37,2.37,0,0,1-.56.69h0a2.29,2.29,0,0,1-.43.32l.93,2.69a1,1,0,0,0,1.34.54,14,14,0,0,1,1.69-.63,2.66,2.66,0,0,0,1-.56,2.28,2.28,0,0,0,.57-.69l2.41-5.1a1.51,1.51,0,0,1,1.55-.8l2.82.52a1.31,1.31,0,0,1,.28.09ZM54.7,339.4a.82.82,0,0,1-.28-.42l-1.06-3.09a.94.94,0,0,0-1.34-.54,12.15,12.15,0,0,1-1.7.63,2.29,2.29,0,0,0-.53.25l.14.4a.78.78,0,0,0,.38.46h0Zm-7.18-45.59a.57.57,0,0,0-.31-.07.73.73,0,0,0-.5.22l-4.05,3.44a1.14,1.14,0,0,0-.15.16,1.27,1.27,0,0,0-.11.13,3,3,0,0,0-.34.67c0,.06,0,.12,0,.17h0a1.8,1.8,0,0,0-.09.67l.41,4a3.12,3.12,0,0,1-.57,1.94c-.65.85-1.26,1.74-1.83,2.65a2.21,2.21,0,0,1-.9.74,1.55,1.55,0,0,1-.36.13.86.86,0,0,1-.17,0l-.24,0-2.69,0h-.06l-.22,0a.73.73,0,0,0-.2.05h0a1,1,0,0,0-.21.09,1.71,1.71,0,0,0-.79.82l-2.29,5.76a1.06,1.06,0,0,0,.48,1.34l3,1.6a1.35,1.35,0,0,1,.09.77,25.83,25.83,0,0,0-.36,2.71,3.32,3.32,0,0,1-.82,1.87l0,0-3.53,3.51a1,1,0,0,0-.16.2l0,0a1,1,0,0,0-.13.25,2.12,2.12,0,0,0-.22,1.36l.86,4a.81.81,0,0,0,.34.54L35.81,336a.76.76,0,0,1-.33-.52l-.86-4a1.88,1.88,0,0,1,0-.78,2.09,2.09,0,0,1,.53-1.07l3.52-3.51,0,0a3.43,3.43,0,0,0,.83-1.87,25.83,25.83,0,0,1,.36-2.71,1.36,1.36,0,0,0-.8-1.47l-2.21-.83a1.08,1.08,0,0,1-.62-1.41L38.58,312a1.59,1.59,0,0,1,.41-.56,1.66,1.66,0,0,1,1.1-.45l2.69,0a1.67,1.67,0,0,0,.77-.18,2.12,2.12,0,0,0,.89-.75c.57-.9,1.18-1.79,1.83-2.64a3.07,3.07,0,0,0,.57-2l-.4-3.95a1.66,1.66,0,0,1,.07-.69,2.2,2.2,0,0,1,.65-1.12l4-3.45a.73.73,0,0,1,.82-.15ZM43,336.2a1.86,1.86,0,0,0-.51-1.74,6.8,6.8,0,0,1-.75-.85,1.07,1.07,0,0,0-1.5-.28l-2.05,1.47L36.78,339a.93.93,0,0,0,.42,1.12h0l4.51,2.36a.92.92,0,0,1-.42-1.12Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.48,297.24h0a.69.69,0,0,0-.76.1l-1.54,1.1-.32,1a1.81,1.81,0,0,0,.51,1.74,8,8,0,0,1,.75.86,1.08,1.08,0,0,0,1.5.26l3.6-2.58a.73.73,0,0,1,.75-.11ZM61.34,311c-.64-3-2.61-4.39-5.07-4.09a8.54,8.54,0,0,1,.58,1.73c1,4.72-1.73,11.57-6.11,15.31a9.05,9.05,0,0,1-4.65,2.31c1.61,3.13,5.37,3.28,9.15.05C59.62,322.61,62.35,315.76,61.34,311Zm-.74-20.29h0a.92.92,0,0,0-.29-.11l-2.81-.52a1.52,1.52,0,0,0-1.55.8L53.53,296a2.37,2.37,0,0,1-.56.69h0a2.29,2.29,0,0,1-.43.32l.93,2.69a1,1,0,0,0,1.34.54,14,14,0,0,1,1.69-.63,2.66,2.66,0,0,0,1-.56,2.28,2.28,0,0,0,.57-.69l2.41-5.1a1.51,1.51,0,0,1,1.55-.8l2.82.52a1.31,1.31,0,0,1,.28.09ZM54.7,339.4a.82.82,0,0,1-.28-.42l-1.06-3.09a.94.94,0,0,0-1.34-.54,12.15,12.15,0,0,1-1.7.63,2.29,2.29,0,0,0-.53.25l.14.4a.78.78,0,0,0,.38.46h0Zm-7.18-45.59a.57.57,0,0,0-.31-.07.73.73,0,0,0-.5.22l-4.05,3.44a1.14,1.14,0,0,0-.15.16,1.27,1.27,0,0,0-.11.13,3,3,0,0,0-.34.67c0,.06,0,.12,0,.17h0a1.8,1.8,0,0,0-.09.67l.41,4a3.12,3.12,0,0,1-.57,1.94c-.65.85-1.26,1.74-1.83,2.65a2.21,2.21,0,0,1-.9.74,1.55,1.55,0,0,1-.36.13.86.86,0,0,1-.17,0l-.24,0-2.69,0h-.06l-.22,0a.73.73,0,0,0-.2.05h0a1,1,0,0,0-.21.09,1.71,1.71,0,0,0-.79.82l-2.29,5.76a1.06,1.06,0,0,0,.48,1.34l3,1.6a1.35,1.35,0,0,1,.09.77,25.83,25.83,0,0,0-.36,2.71,3.32,3.32,0,0,1-.82,1.87l0,0-3.53,3.51a1,1,0,0,0-.16.2l0,0a1,1,0,0,0-.13.25,2.12,2.12,0,0,0-.22,1.36l.86,4a.81.81,0,0,0,.34.54L35.81,336a.76.76,0,0,1-.33-.52l-.86-4a1.88,1.88,0,0,1,0-.78,2.09,2.09,0,0,1,.53-1.07l3.52-3.51,0,0a3.43,3.43,0,0,0,.83-1.87,25.83,25.83,0,0,1,.36-2.71,1.36,1.36,0,0,0-.8-1.47l-2.21-.83a1.08,1.08,0,0,1-.62-1.41L38.58,312a1.59,1.59,0,0,1,.41-.56,1.66,1.66,0,0,1,1.1-.45l2.69,0a1.67,1.67,0,0,0,.77-.18,2.12,2.12,0,0,0,.89-.75c.57-.9,1.18-1.79,1.83-2.64a3.07,3.07,0,0,0,.57-2l-.4-3.95a1.66,1.66,0,0,1,.07-.69,2.2,2.2,0,0,1,.65-1.12l4-3.45a.73.73,0,0,1,.82-.15ZM43,336.2a1.86,1.86,0,0,0-.51-1.74,6.8,6.8,0,0,1-.75-.85,1.07,1.07,0,0,0-1.5-.28l-2.05,1.47L36.78,339a.93.93,0,0,0,.42,1.12h0l4.51,2.36a.92.92,0,0,1-.42-1.12Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.69,326.12l-3.52,3.51a2.09,2.09,0,0,0-.53,1.07l-4.49-2.35a2.73,2.73,0,0,1,.2-.59,1,1,0,0,1,.13-.25l0,0a1,1,0,0,1,.16-.2l3.53-3.51Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.55,310.86a1.67,1.67,0,0,1-.77.18l-2.69,0a1.66,1.66,0,0,0-1.1.45l-4.49-2.36a1.7,1.7,0,0,1,.38-.26,1,1,0,0,1,.21-.09h0a.73.73,0,0,1,.2-.05l.22,0h.06l2.69,0,.24,0,.17,0,.35-.14h0Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,299.59a.7.7,0,0,0-.75.12l-3.6,2.58a1.08,1.08,0,0,1-1.5-.28,6.87,6.87,0,0,0-.76-.85,1.84,1.84,0,0,1-.5-1.75l.32-1,1.54-1.11a.69.69,0,0,1,.76-.1h0Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.09,293.1a1.31,1.31,0,0,0-.28-.09L62,292.49a1.51,1.51,0,0,0-1.55.8L58,298.39a2.28,2.28,0,0,1-.57.69L53,296.72a2.37,2.37,0,0,0,.56-.69l2.42-5.1a1.52,1.52,0,0,1,1.55-.8l2.81.52a.92.92,0,0,1,.29.11h0Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,296.16a.73.73,0,0,0-.82.15l-4,3.45a2.2,2.2,0,0,0-.65,1.12L42,298.53s0-.11,0-.17a3,3,0,0,1,.34-.67,1.27,1.27,0,0,1,.11-.13,1.14,1.14,0,0,1,.15-.16L46.71,294a.73.73,0,0,1,.5-.22.57.57,0,0,1,.31.07Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.69,326.12l-3.52,3.51a2.09,2.09,0,0,0-.53,1.07l-4.49-2.35a2.73,2.73,0,0,1,.2-.59,1,1,0,0,1,.13-.25l0,0a1,1,0,0,1,.16-.2l3.53-3.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.55,310.86a1.67,1.67,0,0,1-.77.18l-2.69,0a1.66,1.66,0,0,0-1.1.45l-4.49-2.36a1.7,1.7,0,0,1,.38-.26,1,1,0,0,1,.21-.09h0a.73.73,0,0,1,.2-.05l.22,0h.06l2.69,0,.24,0,.17,0,.35-.14h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,299.59a.7.7,0,0,0-.75.12l-3.6,2.58a1.08,1.08,0,0,1-1.5-.28,6.87,6.87,0,0,0-.76-.85,1.84,1.84,0,0,1-.5-1.75l.32-1,1.54-1.11a.69.69,0,0,1,.76-.1h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.09,293.1a1.31,1.31,0,0,0-.28-.09L62,292.49a1.51,1.51,0,0,0-1.55.8L58,298.39a2.28,2.28,0,0,1-.57.69L53,296.72a2.37,2.37,0,0,0,.56-.69l2.42-5.1a1.52,1.52,0,0,1,1.55-.8l2.81.52a.92.92,0,0,1,.29.11h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,296.16a.73.73,0,0,0-.82.15l-4,3.45a2.2,2.2,0,0,0-.65,1.12L42,298.53s0-.11,0-.17a3,3,0,0,1,.34-.67,1.27,1.27,0,0,1,.11-.13,1.14,1.14,0,0,1,.15-.16L46.71,294a.73.73,0,0,1,.5-.22.57.57,0,0,1,.31.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.19,304.14l-.85-4a.66.66,0,0,0-1.12-.43l-3.6,2.58a1.08,1.08,0,0,1-1.5-.28,6.8,6.8,0,0,0-.75-.85,1.84,1.84,0,0,1-.51-1.74l1.68-5.18A.92.92,0,0,0,64.8,293L62,292.49a1.53,1.53,0,0,0-1.55.8L58,298.38a2.75,2.75,0,0,1-1.54,1.26,12.51,12.51,0,0,0-1.69.63,1,1,0,0,1-1.34-.55l-1.07-3.08a.7.7,0,0,0-1.19-.33l-4,3.45a2.32,2.32,0,0,0-.72,1.8l.41,4a3.16,3.16,0,0,1-.58,2c-.65.85-1.26,1.73-1.83,2.65a2.14,2.14,0,0,1-1.66.92l-2.69,0a1.71,1.71,0,0,0-1.5,1l-2.3,5.76a1.07,1.07,0,0,0,.62,1.4l2.2.84a1.35,1.35,0,0,1,.81,1.46,26.37,26.37,0,0,0-.36,2.72,3.36,3.36,0,0,1-.83,1.87l-3.56,3.55a2.25,2.25,0,0,0-.55,1.84l.86,4a.66.66,0,0,0,1.12.43l3.6-2.58a1.07,1.07,0,0,1,1.49.28,7.79,7.79,0,0,0,.76.85,1.81,1.81,0,0,1,.5,1.74l-1.67,5.17a.93.93,0,0,0,.74,1.24l2.81.51a1.49,1.49,0,0,0,1.54-.79l2.42-5.1A2.77,2.77,0,0,1,50.33,336a12.6,12.6,0,0,0,1.69-.64,1,1,0,0,1,1.34.55L54.43,339a.7.7,0,0,0,1.19.33l4-3.45a2.36,2.36,0,0,0,.72-1.81l-.41-4a3.2,3.2,0,0,1,.57-1.94,30.49,30.49,0,0,0,1.84-2.65,2.18,2.18,0,0,1,1.66-.93l2.69,0a1.73,1.73,0,0,0,1.5-1l2.3-5.76a1.07,1.07,0,0,0-.62-1.4l-2.21-.84a1.36,1.36,0,0,1-.8-1.47,25.83,25.83,0,0,0,.36-2.71,3.33,3.33,0,0,1,.83-1.87L71.65,306A2.23,2.23,0,0,0,72.19,304.14ZM55.24,326.35c-4.38,3.74-8.75,2.95-9.76-1.77s1.72-11.57,6.1-15.31,8.75-2.95,9.76,1.77S59.62,322.61,55.24,326.35Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.91,295.22h0a.88.88,0,0,0-.93.06l-1.94,1.2-.45,1.14a2.18,2.18,0,0,0,.46,2.13,8.49,8.49,0,0,1,.84,1.09,1.29,1.29,0,0,0,1.77.44l4.53-2.81a.87.87,0,0,1,.91-.07Zm-7.3,16.16c-.53-3.62-2.77-5.49-5.76-5.32a8.94,8.94,0,0,1,.56,2.12c.83,5.75-3,13.76-8.58,17.89a11,11,0,0,1-5.78,2.4c1.68,3.88,6.19,4.37,11,.8C107.6,325.14,111.44,317.13,110.61,311.38Zm.76-24.43h0a1,1,0,0,0-.34-.15L107.7,286a1.81,1.81,0,0,0-1.93.83l-3.32,5.93a2.8,2.8,0,0,1-.73.78h0a3.55,3.55,0,0,1-.55.34l.89,3.31a1.16,1.16,0,0,0,1.57.77,15.26,15.26,0,0,1,2.08-.63,3.43,3.43,0,0,0,1.22-.59,2.71,2.71,0,0,0,.73-.79L111,290a1.86,1.86,0,0,1,1.93-.83l3.34.85a1.22,1.22,0,0,1,.33.14Zm-11,57.94a.86.86,0,0,1-.3-.52l-1-3.79a1.14,1.14,0,0,0-1.56-.77,14.2,14.2,0,0,1-2.09.63,2.28,2.28,0,0,0-.65.25l.13.49a1,1,0,0,0,.42.59h0Zm-4.93-55.33a.66.66,0,0,0-.36-.11,1,1,0,0,0-.62.22l-5.14,3.81a.86.86,0,0,0-.2.18,1.92,1.92,0,0,0-.14.15,3.15,3.15,0,0,0-.46.78l-.07.19h0a2.45,2.45,0,0,0-.15.81l.17,4.79a3.82,3.82,0,0,1-.85,2.29,37.23,37.23,0,0,0-2.41,3,2.55,2.55,0,0,1-1.14.82,1.8,1.8,0,0,1-.44.12l-.21,0a1.43,1.43,0,0,1-.29,0l-3.23-.25H79.8a1.18,1.18,0,0,0-.26,0,1,1,0,0,0-.24,0h0l-.26.1a2.87,2.87,0,0,0-.48.28,2,2,0,0,0-.53.64l-3.22,6.73a1.29,1.29,0,0,0,.46,1.65l3.53,2.16a1.6,1.6,0,0,1,.06.94,29.32,29.32,0,0,0-.65,3.23A4.07,4.07,0,0,1,77,324.41l0,0-4.52,3.93a1.21,1.21,0,0,0-.22.23l0,0a1.12,1.12,0,0,0-.19.29,2.63,2.63,0,0,0-.38,1.61l.72,4.88a.93.93,0,0,0,.37.67l5.18,3.18a.92.92,0,0,1-.35-.65l-.7-4.88a2.3,2.3,0,0,1,.07-.93,2.68,2.68,0,0,1,.73-1.25l4.51-3.92.06,0a4.11,4.11,0,0,0,1.15-2.17A26.77,26.77,0,0,1,84,322.2a1.63,1.63,0,0,0-.85-1.83l-2.58-1.18a1.3,1.3,0,0,1-.63-1.74l3.22-6.73a1.85,1.85,0,0,1,.54-.65,2,2,0,0,1,1.35-.44l3.23.24a2,2,0,0,0,.94-.16,2.5,2.5,0,0,0,1.13-.82c.76-1,1.57-2.06,2.41-3a3.76,3.76,0,0,0,.85-2.29l-.17-4.79a2.07,2.07,0,0,1,.15-.82,2.67,2.67,0,0,1,.87-1.29l5.13-3.81a.86.86,0,0,1,1-.12Zm-8.92,50.55A2.22,2.22,0,0,0,86,338a7.63,7.63,0,0,1-.83-1.09,1.3,1.3,0,0,0-1.78-.45L80.82,338l-2,5a1.1,1.1,0,0,0,.41,1.37h0l5.22,3.21a1.13,1.13,0,0,1-.41-1.39Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.91,295.22h0a.88.88,0,0,0-.93.06l-1.94,1.2-.45,1.14a2.18,2.18,0,0,0,.46,2.13,8.49,8.49,0,0,1,.84,1.09,1.29,1.29,0,0,0,1.77.44l4.53-2.81a.87.87,0,0,1,.91-.07Zm-7.3,16.16c-.53-3.62-2.77-5.49-5.76-5.32a8.94,8.94,0,0,1,.56,2.12c.83,5.75-3,13.76-8.58,17.89a11,11,0,0,1-5.78,2.4c1.68,3.88,6.19,4.37,11,.8C107.6,325.14,111.44,317.13,110.61,311.38Zm.76-24.43h0a1,1,0,0,0-.34-.15L107.7,286a1.81,1.81,0,0,0-1.93.83l-3.32,5.93a2.8,2.8,0,0,1-.73.78h0a3.55,3.55,0,0,1-.55.34l.89,3.31a1.16,1.16,0,0,0,1.57.77,15.26,15.26,0,0,1,2.08-.63,3.43,3.43,0,0,0,1.22-.59,2.71,2.71,0,0,0,.73-.79L111,290a1.86,1.86,0,0,1,1.93-.83l3.34.85a1.22,1.22,0,0,1,.33.14Zm-11,57.94a.86.86,0,0,1-.3-.52l-1-3.79a1.14,1.14,0,0,0-1.56-.77,14.2,14.2,0,0,1-2.09.63,2.28,2.28,0,0,0-.65.25l.13.49a1,1,0,0,0,.42.59h0Zm-4.93-55.33a.66.66,0,0,0-.36-.11,1,1,0,0,0-.62.22l-5.14,3.81a.86.86,0,0,0-.2.18,1.92,1.92,0,0,0-.14.15,3.15,3.15,0,0,0-.46.78l-.07.19h0a2.45,2.45,0,0,0-.15.81l.17,4.79a3.82,3.82,0,0,1-.85,2.29,37.23,37.23,0,0,0-2.41,3,2.55,2.55,0,0,1-1.14.82,1.8,1.8,0,0,1-.44.12l-.21,0a1.43,1.43,0,0,1-.29,0l-3.23-.25H79.8a1.18,1.18,0,0,0-.26,0,1,1,0,0,0-.24,0h0l-.26.1a2.87,2.87,0,0,0-.48.28,2,2,0,0,0-.53.64l-3.22,6.73a1.29,1.29,0,0,0,.46,1.65l3.53,2.16a1.6,1.6,0,0,1,.06.94,29.32,29.32,0,0,0-.65,3.23A4.07,4.07,0,0,1,77,324.41l0,0-4.52,3.93a1.21,1.21,0,0,0-.22.23l0,0a1.12,1.12,0,0,0-.19.29,2.63,2.63,0,0,0-.38,1.61l.72,4.88a.93.93,0,0,0,.37.67l5.18,3.18a.92.92,0,0,1-.35-.65l-.7-4.88a2.3,2.3,0,0,1,.07-.93,2.68,2.68,0,0,1,.73-1.25l4.51-3.92.06,0a4.11,4.11,0,0,0,1.15-2.17A26.77,26.77,0,0,1,84,322.2a1.63,1.63,0,0,0-.85-1.83l-2.58-1.18a1.3,1.3,0,0,1-.63-1.74l3.22-6.73a1.85,1.85,0,0,1,.54-.65,2,2,0,0,1,1.35-.44l3.23.24a2,2,0,0,0,.94-.16,2.5,2.5,0,0,0,1.13-.82c.76-1,1.57-2.06,2.41-3a3.76,3.76,0,0,0,.85-2.29l-.17-4.79a2.07,2.07,0,0,1,.15-.82,2.67,2.67,0,0,1,.87-1.29l5.13-3.81a.86.86,0,0,1,1-.12Zm-8.92,50.55A2.22,2.22,0,0,0,86,338a7.63,7.63,0,0,1-.83-1.09,1.3,1.3,0,0,0-1.78-.45L80.82,338l-2,5a1.1,1.1,0,0,0,.41,1.37h0l5.22,3.21a1.13,1.13,0,0,1-.41-1.39Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.18,327.65l-4.51,3.92a2.68,2.68,0,0,0-.73,1.25l-5.19-3.19a3.22,3.22,0,0,1,.28-.69,1.12,1.12,0,0,1,.19-.29l0,0a1.21,1.21,0,0,1,.22-.23L77,324.45Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.26,309.71a2,2,0,0,1-.94.16l-3.23-.24a2,2,0,0,0-1.35.44l-5.21-3.19a2.87,2.87,0,0,1,.48-.28l.26-.1h0a1,1,0,0,1,.24,0,1.18,1.18,0,0,1,.26,0h.08l3.23.25a1.43,1.43,0,0,0,.29,0l.21,0a4.14,4.14,0,0,0,.43-.13h0Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.1,298.41a.85.85,0,0,0-.91.08l-4.53,2.81a1.29,1.29,0,0,1-1.77-.46,9,9,0,0,0-.84-1.09,2.17,2.17,0,0,1-.46-2.13l.45-1.12,1.94-1.21a.86.86,0,0,1,.93-.06h0Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.57,290.14a1.22,1.22,0,0,0-.33-.14l-3.34-.85A1.86,1.86,0,0,0,111,290l-3.31,5.93a2.71,2.71,0,0,1-.73.79l-5.21-3.2a2.8,2.8,0,0,0,.73-.78l3.32-5.93a1.81,1.81,0,0,1,1.93-.83l3.33.85a1,1,0,0,1,.34.15h0Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.63,292.75a.86.86,0,0,0-1,.12l-5.13,3.81a2.67,2.67,0,0,0-.87,1.29l-5.21-3.19.07-.19a3.15,3.15,0,0,1,.46-.78,1.92,1.92,0,0,1,.14-.15.86.86,0,0,1,.2-.18l5.14-3.81a1,1,0,0,1,.62-.22.66.66,0,0,1,.36.11Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.18,327.65l-4.51,3.92a2.68,2.68,0,0,0-.73,1.25l-5.19-3.19a3.22,3.22,0,0,1,.28-.69,1.12,1.12,0,0,1,.19-.29l0,0a1.21,1.21,0,0,1,.22-.23L77,324.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.26,309.71a2,2,0,0,1-.94.16l-3.23-.24a2,2,0,0,0-1.35.44l-5.21-3.19a2.87,2.87,0,0,1,.48-.28l.26-.1h0a1,1,0,0,1,.24,0,1.18,1.18,0,0,1,.26,0h.08l3.23.25a1.43,1.43,0,0,0,.29,0l.21,0a4.14,4.14,0,0,0,.43-.13h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.1,298.41a.85.85,0,0,0-.91.08l-4.53,2.81a1.29,1.29,0,0,1-1.77-.46,9,9,0,0,0-.84-1.09,2.17,2.17,0,0,1-.46-2.13l.45-1.12,1.94-1.21a.86.86,0,0,1,.93-.06h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.57,290.14a1.22,1.22,0,0,0-.33-.14l-3.34-.85A1.86,1.86,0,0,0,111,290l-3.31,5.93a2.71,2.71,0,0,1-.73.79l-5.21-3.2a2.8,2.8,0,0,0,.73-.78l3.32-5.93a1.81,1.81,0,0,1,1.93-.83l3.33.85a1,1,0,0,1,.34.15h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.63,292.75a.86.86,0,0,0-1,.12l-5.13,3.81a2.67,2.67,0,0,0-.87,1.29l-5.21-3.19.07-.19a3.15,3.15,0,0,1,.46-.78,1.92,1.92,0,0,1,.14-.15.86.86,0,0,1,.2-.18l5.14-3.81a1,1,0,0,1,.62-.22.66.66,0,0,1,.36.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.21,304l-.71-4.88a.8.8,0,0,0-1.31-.61l-4.53,2.8a1.28,1.28,0,0,1-1.77-.45,9.13,9.13,0,0,0-.84-1.08,2.21,2.21,0,0,1-.46-2.14l2.43-6.07a1.12,1.12,0,0,0-.78-1.55l-3.34-.84A1.8,1.8,0,0,0,111,290l-3.32,5.92a3.29,3.29,0,0,1-1.94,1.38,15,15,0,0,0-2.09.63,1.14,1.14,0,0,1-1.56-.77l-1-3.8a.84.84,0,0,0-1.41-.48l-5.13,3.81a2.84,2.84,0,0,0-1,2.11l.17,4.79a3.77,3.77,0,0,1-.84,2.29c-.85,1-1.66,2-2.42,3a2.63,2.63,0,0,1-2.07,1l-3.23-.25a2.07,2.07,0,0,0-1.89,1.09L80,317.44a1.29,1.29,0,0,0,.63,1.74l2.58,1.19a1.6,1.6,0,0,1,.84,1.82,32,32,0,0,0-.64,3.24,4.11,4.11,0,0,1-1.15,2.17l-4.57,4a2.66,2.66,0,0,0-.8,2.17l.7,4.88a.8.8,0,0,0,1.31.61l4.53-2.81a1.3,1.3,0,0,1,1.77.45A9.25,9.25,0,0,0,86,338a2.2,2.2,0,0,1,.47,2.13l-2.44,6.08a1.12,1.12,0,0,0,.79,1.55l3.33.84a1.82,1.82,0,0,0,1.93-.83l3.31-5.92a3.31,3.31,0,0,1,2-1.38,18.1,18.1,0,0,0,2.08-.63,1.15,1.15,0,0,1,1.57.77l1,3.79a.83.83,0,0,0,1.4.49l5.14-3.81a2.83,2.83,0,0,0,1-2.11l-.17-4.79a3.76,3.76,0,0,1,.85-2.29c.85-1,1.65-2,2.41-3a2.63,2.63,0,0,1,2.08-1l3.22.25a2.08,2.08,0,0,0,1.89-1.09l3.22-6.73a1.29,1.29,0,0,0-.62-1.74l-2.58-1.18a1.62,1.62,0,0,1-.85-1.83,28.86,28.86,0,0,0,.65-3.23,4.07,4.07,0,0,1,1.15-2.18l4.56-4A2.71,2.71,0,0,0,124.21,304ZM102,329.27c-5.57,4.13-10.75,2.83-11.58-2.92s3-13.76,8.58-17.89,10.74-2.83,11.57,2.92S107.6,325.14,102,329.27Z",
    style: {
      fill: "#FF577F"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.15,354.55c-7.88-8.13-12.51-41.23-4.82-47.68h39.11c7.68,6.45,3.06,39.53-4.82,47.67l-.21.23a3.45,3.45,0,0,1-.28.26,8.91,8.91,0,0,1-.71.64,1.39,1.39,0,0,1-.19.15c-.19.16-.38.31-.59.46s-.68.46-1,.66c-6.48,3.78-17,3.78-23.48,0h0a11.88,11.88,0,0,1-1-.67c-.2-.13-.38-.28-.56-.42l-.23-.19c-.24-.2-.47-.4-.69-.61l-.31-.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,304.28c8.92,5.21,8.92,13.65,0,18.86s-23.39,5.21-32.32,0-8.92-13.65,0-18.86S448.12,299.07,457,304.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457,304.28c8.92,5.21,8.92,13.65,0,18.86s-23.39,5.21-32.32,0-8.92-13.65,0-18.86S448.12,299.07,457,304.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M452.75,306.78c6.55,3.83,6.55,10,0,13.86s-17.18,3.82-23.73,0-6.56-10,0-13.86S446.2,303,452.75,306.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,313.36c6.55-3.83,17.17-3.83,23.73,0a10.88,10.88,0,0,1,3.92,3.64,11,11,0,0,1-3.92,3.64c-6.56,3.82-17.18,3.82-23.73,0a11,11,0,0,1-3.93-3.64A10.92,10.92,0,0,1,429,313.36Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M462.56,242.67,454,250.33l7.76-2.56a34.25,34.25,0,0,1-3.11,13.06L449,266l7.7-1.18a14.46,14.46,0,0,1-.41,6.79c-.08.3-.17.61-.28.92-.68,2.08-1.67,6-3.33,10.68h0a68.47,68.47,0,0,1-5.37,11.75,48.68,48.68,0,0,1-3.58,5.29l-.24.32q-3.61-2.43-7.54-4.73c-1.5-3.84-3.16-13.17-3.46-20.74-1.13-29,21.76-43.91,39.63-48.2C472.14,226.88,465.6,234,462.56,242.67Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.09,243a21.25,21.25,0,0,0-4.06,4.9,42.28,42.28,0,0,0-2.86,5.71,58.12,58.12,0,0,0-3.51,12.25A53.88,53.88,0,0,0,441,291h0a.42.42,0,1,1-.8.24h0a54.6,54.6,0,0,1-1-25.5A58.64,58.64,0,0,1,443,253.53a44.41,44.41,0,0,1,3-5.68A21.67,21.67,0,0,1,450.09,243Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.28,257.73l0,0A221.05,221.05,0,0,1,408.14,280l9.11,2.74L412,284.5l5.67,9.63,10.11,3.11-7,1.94s2.87,11.39,11,16.35c4.49,2.74,6.71,3.21,8.12,1.94,1-.88,1.38-6.29,2.33-11.1s1.26-12.67-3-22.3a29.61,29.61,0,0,0-4.52-7.11C424.06,264.41,403.53,257.89,393.28,257.73Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.28,257.73l0,0A221.05,221.05,0,0,1,408.14,280l9.11,2.74L412,284.5l5.67,9.63,10.11,3.11-7,1.94s2.87,11.39,11,16.35c4.49,2.74,6.71,3.21,8.12,1.94,1-.88,1.38-6.29,2.33-11.1s1.26-12.67-3-22.3a29.61,29.61,0,0,0-4.52-7.11C424.06,264.41,403.53,257.89,393.28,257.73Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,289s0,0,0,0v0a45.67,45.67,0,0,1,3.07,12.56h0A135.66,135.66,0,0,1,439,318a2.38,2.38,0,0,0,.84-.49c1-.88,1.38-6.29,2.33-11.1s1.26-12.67-3-22.29a29.48,29.48,0,0,0-4.52-7.12c-10.59-12.55-31.12-19.07-41.37-19.23,15.65,3,32.23,14,40.2,26.45A31.76,31.76,0,0,1,436,289Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.88,263.14a61.32,61.32,0,0,1,20.51,15.11,40.87,40.87,0,0,1,6.84,10.87,39.08,39.08,0,0,1,2.9,12.47s0,0,0,.05a0,0,0,0,1,0,0,50.29,50.29,0,0,0-3.58-12.15,47.23,47.23,0,0,0-6.59-10.77,54.09,54.09,0,0,0-9.21-8.74,72.16,72.16,0,0,0-10.82-6.73,0,0,0,0,1,0-.07Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.69,268.41h0a29.66,29.66,0,0,0-3.8,0,60.29,60.29,0,0,0-14.67,2.72c-1.77.55-3.54,1.18-5.29,1.9-.88.36-1.75.74-2.61,1.15a42.12,42.12,0,0,0-11.56,7.77,26.71,26.71,0,0,0-4.11,5.16c-.15.24-.31.48-.45.72h0c-.36.64-.69,1.28-1,1.9A36.29,36.29,0,0,0,439,307.35c-.08,4.32,1.11,9.34,1.91,10.2a2.6,2.6,0,0,0,.36.3c1.19.85,3.17.5,6.94-1.34,7.56-3.7,11-13.92,11-13.92l-4.78-1.78,7.92-2.41,5.77-8-5.1-1.22,8.82-2.41a196.76,196.76,0,0,1,14.87-18.35l0,0Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.89,268.38a60.29,60.29,0,0,0-14.67,2.72c-1.77.55-3.54,1.18-5.29,1.9-.88.36-1.75.74-2.61,1.15a42.12,42.12,0,0,0-11.56,7.77,26.71,26.71,0,0,0-4.11,5.16c-.15.24-.31.48-.45.72h0c-.36.64-.69,1.28-1,1.9A36.29,36.29,0,0,0,439,307.35c-.08,4.32,1.11,9.34,1.91,10.2a2.6,2.6,0,0,0,.36.3,2.25,2.25,0,0,0,.79.34c-.53-6.75,3.7-23.53,9.07-30.24,5.59-7,18.47-16.83,35.59-19.52l0,0A29,29,0,0,0,482.89,268.38Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,318.19a57.39,57.39,0,0,1,1.78-14.75,47.79,47.79,0,0,1,5.69-13.77,33.53,33.53,0,0,1,4.8-5.75,48,48,0,0,1,5.75-4.8,55.85,55.85,0,0,1,13.17-6.93,0,0,0,0,1,.06,0s0,.05,0,.05a73.22,73.22,0,0,0-12.72,7.54,60.76,60.76,0,0,0-5.67,4.71A33.32,33.32,0,0,0,450,290a47.65,47.65,0,0,0-5.84,13.51,57,57,0,0,0-2.1,14.64,0,0,0,1,1-.08,0Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.93,400a1.25,1.25,0,0,1-1.25-1.25V318.51a1.25,1.25,0,0,1,2.5,0v80.25A1.25,1.25,0,0,1,178.93,400Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.58,370.8a1.24,1.24,0,0,1-1.16-.79l-24.61-62.29a1.25,1.25,0,0,1,2.32-.91l24.61,62.28a1.25,1.25,0,0,1-1.16,1.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.62,363.32a1.22,1.22,0,0,1-.9-.39l-45.79-48.46-45.71,48.25a1.25,1.25,0,1,1-1.81-1.71L178,311.8a1.26,1.26,0,0,1,.91-.39h0a1.23,1.23,0,0,1,.9.39l46.7,49.41a1.25,1.25,0,0,1-.05,1.77A1.23,1.23,0,0,1,225.62,363.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.28,370.8a1.22,1.22,0,0,1-.46-.09,1.24,1.24,0,0,1-.7-1.62l24.6-62.28a1.25,1.25,0,0,1,2.33.91L130.44,370A1.26,1.26,0,0,1,129.28,370.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.88,361.4l3.26,8.58a.89.89,0,0,1,0,.22v.16a1,1,0,0,1-.49.54,2.16,2.16,0,0,1-2,0,.89.89,0,0,1-.39-.41h0l0-.12-3-8.05Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,361.4,127.72,370a.89.89,0,0,0,0,.22.43.43,0,0,0,0,.16,1,1,0,0,0,.49.54,2.16,2.16,0,0,0,2,0,.89.89,0,0,0,.39-.41h0l0-.12,3-8.05Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.37,392.55v7.1a.72.72,0,0,1-.42.59,2.29,2.29,0,0,1-2,0,.72.72,0,0,1-.42-.59v-7.1A3.06,3.06,0,0,1,180.37,392.55Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.91,310.65c0-1.89-1.65-3.89-5.13-6.15-6.45-4.18-20.84-12.57-29.85-17.56a.1.1,0,0,0-.07-.08c-6.94-4.2-13.41-24.25-18.21-39.48-1.63-5.19-3.64-8.13-6-9.51-.56-.33-2.64-1.47-3.11-1.75-4.71-2.82-10.89.57-18.59,4.78-7.09,3.89-12.63,8.86-13.75,22-.67,8,0,23.37,1.6,35h0c2.36,19.43,5.26,19.46,9.46,22.71,7.24,5.6,23.55,13.46,30.43,16.16,12.46,4.91,22.65-2.65,30.24-6.4A175.59,175.59,0,0,0,223,318.48c1.91-1.39,2.89-2.78,2.87-4.25C225.9,313.65,225.91,311.25,225.91,310.65Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.91,310.65c0-1.89-1.65-3.89-5.13-6.15-6.45-4.18-20.84-12.57-29.85-17.56a.1.1,0,0,0-.07-.08c-6.94-4.2-13.41-24.25-18.21-39.48-1.63-5.19-3.64-8.13-6-9.51-.56-.33-2.64-1.47-3.11-1.75-4.71-2.82-10.89.57-18.59,4.78-7.09,3.89-12.63,8.86-13.75,22-.67,8,0,23.37,1.6,35h0c2.36,19.43,5.26,19.46,9.46,22.71,7.24,5.6,23.55,13.46,30.43,16.16,12.46,4.91,22.65-2.65,30.24-6.4A175.59,175.59,0,0,0,223,318.48c1.91-1.39,2.89-2.78,2.87-4.25C225.9,313.65,225.91,311.25,225.91,310.65Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.36,237.71c-4.66-2.45-10.73.88-18.23,5-4.8,2.64-8.9,5.76-11.39,11.6l-3.16-1.83c2.49-5.82,6.57-8.94,11.36-11.57,7.7-4.21,13.88-7.6,18.6-4.78Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.78,304.5c-4.18-2.71-4.28-3.4-30.05-17.69l.12.05c-6.93-4.23-13.4-24.25-18.2-39.48-4.87-15.46-13-11-24.52-4.67-7.09,3.88-12.63,8.85-13.75,22s1.32,45.88,5.82,49.84c4.91,5.42,24.61,15.51,32.48,18.61,12.46,4.9,22.65-2.66,30.24-6.41A175.59,175.59,0,0,0,223,314.86C227.36,311.72,227,308.51,220.78,304.5Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.85,286.86h0Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.13,242.71c11.52-6.31,19.65-10.79,24.52,4.67,4.8,15.23,11.27,35.28,18.21,39.48,0,0-11.9,0-29.13,9.3-17.92,9.68-20.66,19.14-21.48,18.46-4.53-3.76-7-36.69-5.87-49.88S141,246.59,148.13,242.71Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M208.31,378.49s.25,13.1,2.11,17.17a62.18,62.18,0,0,0,7.59,13c.74.95,2.45,2.74,3.06,3.51a1.43,1.43,0,0,1-.27,2.19c-1.69,1.45-8.54,1.46-12.22-1.6s-6.61-8-8.77-10.38L197,399.12a3.1,3.1,0,0,1-.62-3c.1-.29.2-.64.32-1,1.08-3.65-.71-14.21-.71-14.21C199.49,376.5,204.21,377.53,208.31,378.49Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.78,399.72a4,4,0,0,0,.09,2c.35.93,2.83,2.7,4.12,3.42a8.35,8.35,0,0,1,3.33,3.82c1.46,2.8,3.72,5.85,6.66,7.38a21.66,21.66,0,0,0,12.75,2c5.42-.69,6-3.83,6-3.83s.43-3-.88-3.5S195.78,399.72,195.78,399.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.23,396a8.62,8.62,0,0,0,.55,3.7c1.47,2.27,5.16,3.17,7.17,6.27s4.33,7.84,11.29,9.59,12.4-.21,13.8-2.15.31-3.87-4.07-6.53c-4.65-2.82-10-10-10-10a52.06,52.06,0,0,1-3.55-7.18c-.2-.62-.43-1.34-1-1.57a2.08,2.08,0,0,0-1.64.33A15.9,15.9,0,0,1,204.9,390a9.34,9.34,0,0,1-2.59,0,1.57,1.57,0,0,0-1.21.27,1.4,1.4,0,0,0-.28,1.06,11.18,11.18,0,0,0,.12,1.42,1.34,1.34,0,0,1,0,.69.83.83,0,0,1-.82.5,1.86,1.86,0,0,1-1-.34,4.29,4.29,0,0,1-2.17-3s0-.72-.06-1.38a1.75,1.75,0,0,0-.91,1c-.16.54-.13,1.12-.24,1.66A28.4,28.4,0,0,0,195.23,396Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.23,396a8.62,8.62,0,0,0,.55,3.7c1.47,2.27,5.16,3.17,7.17,6.27s4.33,7.84,11.29,9.59,12.4-.21,13.8-2.15.31-3.87-4.07-6.53c-4.65-2.82-10-10-10-10a52.06,52.06,0,0,1-3.55-7.18c-.2-.62-.43-1.34-1-1.57a2.08,2.08,0,0,0-1.64.33A15.9,15.9,0,0,1,204.9,390a9.34,9.34,0,0,1-2.59,0,1.57,1.57,0,0,0-1.21.27,1.4,1.4,0,0,0-.28,1.06,11.18,11.18,0,0,0,.12,1.42,1.34,1.34,0,0,1,0,.69.83.83,0,0,1-.82.5,1.86,1.86,0,0,1-1-.34,4.29,4.29,0,0,1-2.17-3s0-.72-.06-1.38a1.75,1.75,0,0,0-.91,1c-.16.54-.13,1.12-.24,1.66A28.4,28.4,0,0,0,195.23,396Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.65,362.23s1,13.49,2.73,17.63a60.79,60.79,0,0,0,7,13.3c.69,1,2.32,2.85,2.89,3.65a1.42,1.42,0,0,1-.36,2.17c-1.76,1.38-8.6,1.08-12.13-2.14s-6.26-8.24-8.31-10.76l-2.69-3.36a3.09,3.09,0,0,1-.48-3c.11-.29.23-.63.37-1,1.23-3.59-2-13.55-2-13.55C228.4,360.91,233.6,361.08,237.65,362.23Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.56,384.12a4,4,0,0,0,.09,2c.35.93,2.84,2.7,4.12,3.42a8.3,8.3,0,0,1,3.33,3.82c1.46,2.8,3.72,5.85,6.66,7.38a21.74,21.74,0,0,0,12.75,2c5.42-.69,6-3.83,6-3.83s.43-3-.88-3.5S225.56,384.12,225.56,384.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.77,381.3a13.34,13.34,0,0,1-1.36-2.19c-.39-.84-.78-1.72-1.12-2.57-.48-1.17-.91-2.36-1.38-3.54a2.14,2.14,0,0,0-.63-1,1.66,1.66,0,0,0-1.74.08c-.53.3-1,.74-1.52,1a10.38,10.38,0,0,1-2.9.58c-2,.36-2.68,1.66-2.4,3.5a1.34,1.34,0,0,1,0,.69.84.84,0,0,1-.82.5,1.86,1.86,0,0,1-1-.34,4.16,4.16,0,0,1-2.07-3s0-.71-.16-1.36a1.75,1.75,0,0,0-.91,1c-.16.53-.13,1.11-.24,1.66a28.26,28.26,0,0,0-.56,4.1,8.6,8.6,0,0,0,.55,3.7c1.47,2.27,5.16,3.18,7.17,6.28s4.34,7.84,11.29,9.59,12.4-.21,13.8-2.15.31-3.88-4.07-6.53C249.1,388.48,243.77,381.31,243.77,381.3Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.77,381.3a13.34,13.34,0,0,1-1.36-2.19c-.39-.84-.78-1.72-1.12-2.57-.48-1.17-.91-2.36-1.38-3.54a2.14,2.14,0,0,0-.63-1,1.66,1.66,0,0,0-1.74.08c-.53.3-1,.74-1.52,1a10.38,10.38,0,0,1-2.9.58c-2,.36-2.68,1.66-2.4,3.5a1.34,1.34,0,0,1,0,.69.84.84,0,0,1-.82.5,1.86,1.86,0,0,1-1-.34,4.16,4.16,0,0,1-2.07-3s0-.71-.16-1.36a1.75,1.75,0,0,0-.91,1c-.16.53-.13,1.11-.24,1.66a28.26,28.26,0,0,0-.56,4.1,8.6,8.6,0,0,0,.55,3.7c1.47,2.27,5.16,3.18,7.17,6.28s4.34,7.84,11.29,9.59,12.4-.21,13.8-2.15.31-3.88-4.07-6.53C249.1,388.48,243.77,381.31,243.77,381.3Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.44,286.86l15.06.33,33.65-2.7s30.89,17.28,35.29,27c2.55,5.64,5.46,48.42,5.9,54.79-2.32,1.84-10.5,3.57-13.33,3.09-1.76-5.06-2.33-6.78-4.78-14.24-2-6.07-3.84-10.13-5.27-14.33a61.88,61.88,0,0,1-3-15.2s-4.22-3.24-16.27-12c4.51,4.93,11.67,12.9,12.55,14.87,2.5,5.65.58,48.52.58,54.14C207,385,198.18,386,196,384.43c-1.34-7.5-3.12-13.63-5-21.24-3.39-13.44-1.87-19.6-1.37-24,0,0-8.42-5.79-20.29-13.85-5.62-3.82-10.87-6.92-14.13-10.68C149.18,307.79,148.53,295.6,148.44,286.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.73,313.59l-9.91-10a16.87,16.87,0,0,0,9-12.07s2.15,6.17-3.49,12.66l6.91,8.43,13.74,13Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.63,222.49c7.19-.11,11.38,2.35,13.86,8s12.3,34.74,12.3,34.74,14.92,7.59,23.11,10.85l-7.93,7.6s-19.78-5-23.29-6.32-3.88-1.74-8.57-13.27C188.41,247.63,185.63,222.49,185.63,222.49Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.3,222.49c4.22-.58,11-.24,14.31,4.15s11.76,30.73,11.76,30.73a21.53,21.53,0,0,1-14.8,7L184.71,239Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.17,222.79c-4.32.18-14.61,2.23-18.46,3.07-4.68,1.6-.28,1.35-2.55,7.82-3.39,9.67-2.34,23-2.34,32.13,0,12.13.28,26.17.28,26.17,10.25,8.66,43.65,4.65,49.24-7.49,0,0-2.85-14.29-.88-42,.88-12.4-3.54-20.06-12.13-20.06C184.33,222.47,175.5,222.6,171.17,222.79Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.17,222.79c-4.32.18-14.61,2.23-18.46,3.07-4.68,1.6-.28,1.35-2.55,7.82-3.39,9.67-2.34,23-2.34,32.13,0,12.13.28,26.17.28,26.17,10.25,8.66,43.65,4.65,49.24-7.49,0,0-2.85-14.29-.88-42,.88-12.4-3.54-20.06-12.13-20.06C184.33,222.47,175.5,222.6,171.17,222.79Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,191.31a8.91,8.91,0,1,0,8.2-9.56A8.9,8.9,0,0,0,175,191.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.62,202.2s2.87,10.08,3.84,11.7a4.5,4.5,0,0,0,2.74,2l-.7-7.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.14,187.33s-1.53-.26-2.94,2.35c-1.2,2.24-1.15,7.06,1.42,12.52l4,.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.84,189.51,153,190a2.29,2.29,0,0,1,2-2.73A2.69,2.69,0,0,1,157.84,189.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.16,188.41l-3.84-3.17a2.31,2.31,0,0,1,3.38-.39A2.63,2.63,0,0,1,157.16,188.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.78,202.28a14.48,14.48,0,0,1-3.05-1.93c-1.06-1-4.2-1.76-5.52,1.85s1.67,6.78,4,7.8c2.07.9,4.2-1.6,4.2-1.6l.89,16.07c8.08,10.71,23,8,15.89-.83l-.5-5.2a26.41,26.41,0,0,0,5.85-.13c3.14-.75,4.41-2.55,5.2-6.13a51.05,51.05,0,0,0,.93-13.18,52.73,52.73,0,0,0-.92-8c-2.53-11.15-16.64-13-23.74-7.55S162.78,202.28,162.78,202.28Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.82,189.38a25.76,25.76,0,0,1-8.46-1.26,1.11,1.11,0,0,0-.82,0,1.05,1.05,0,0,0-.41.77,26,26,0,0,1-.91,4,5.77,5.77,0,0,1-2.49,3.19c-.43.23-.92.39-1.15.84a2.29,2.29,0,0,0-.18,1.39,10.73,10.73,0,0,0,.54,1.75c.27.8.75,2.18.38,3a1.33,1.33,0,0,1-1.91.61,7.72,7.72,0,0,1-1.79-1.64,12.81,12.81,0,0,0-1.89-1.65c-.65-.42-.58-1.57-.8-2.28-.46-1.42-.8-2.89-1.12-4.35-.27-1.23-.58-2.49-.75-3.74a17.47,17.47,0,0,1-.26-4.27,7.44,7.44,0,0,1,1.31-3.4c.07-.1.14-.21.22-.31,2-2.88,4.93-4.28,8.29-5.13,2.6-.66,5.29-1,7.93-1.48a51.08,51.08,0,0,0,8.39-2.38,2.31,2.31,0,0,1,1.17-.22,1.5,1.5,0,0,1,1.08,1.5,4.53,4.53,0,0,1-.56,1.91,9.62,9.62,0,0,1,2.57-1.27,3.24,3.24,0,0,1,2.75.38,3.89,3.89,0,0,1,1.29,3.11,10.54,10.54,0,0,1-5.48,9.24A15.19,15.19,0,0,1,178.82,189.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.69,218.44s-7.2-.95-9.78-2.14a8.34,8.34,0,0,1-3.69-3.27,11.89,11.89,0,0,0,2.26,4c2,2.28,11.36,3.35,11.36,3.35Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.92,199.66A1.47,1.47,0,1,1,174,200a1.47,1.47,0,1,1,2.91-.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.43,195l-2.91,2.14a2,2,0,0,1,.43-2.67A1.72,1.72,0,0,1,174.43,195Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.78,208.91l5.39,1.44a2.71,2.71,0,0,1-3.3,2.18A3.08,3.08,0,0,1,176.78,208.91Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.39,212.46a2.58,2.58,0,0,0-2.75-2.14,2.72,2.72,0,0,0-.77.2,2.91,2.91,0,0,0,2,2A2.53,2.53,0,0,0,180.39,212.46Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.85,194.41l-3.56-.84a1.68,1.68,0,0,1,2.07-1.42A2,2,0,0,1,188.85,194.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.75,198.08a1.51,1.51,0,0,1-1.28,1.73,1.58,1.58,0,1,1,1.28-1.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.83 197.73 182.76 207.08 187.55 204.91 180.83 197.73",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.5,226.52c-1.19-.29-8.32-.15-11.89,7.56-2.62,5.65-8,21-12.5,32.58-8-6.42-17.28-13.2-18.34-14.29-2.86-2.89-3.69-5.23-6.63-8.22a31.94,31.94,0,0,1-4.37-5.37c-.9-1.3-1.8.2-2,1a7.15,7.15,0,0,0,.07,4.1c.39,1.18,1.06,2.55.32,3.54-.62.82-1.83.82-2.85.7A58,58,0,0,1,83,245.74a5.63,5.63,0,0,0-1.89-.38,1.61,1.61,0,0,0-1.35,2.69,5.31,5.31,0,0,0,1.42,1.24,3.31,3.31,0,0,0-.49,3.15c.23.76.7,1.37.91,2.13a6.68,6.68,0,0,0,1.12,2.4,7,7,0,0,0,3.07,1.9,35.34,35.34,0,0,0,7.4,1.92c1.67.24,3.33.5,5,.79a14.4,14.4,0,0,1,4.55,1.12c2.5,1.37,4.5,3.47,6.57,5.39,3.2,3,9.15,9.87,16.85,16.23,4.34,3.59,8.35,3.13,11.69-2.36,1.76-2.89,12.65-27.35,12.65-27.35S159,235.12,152.5,226.52Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.11,266.66a13,13,0,0,1,6,9.74s1.71-7.8-5-12.39Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.93,225.81c-7.22.56-11.34,3.41-14.48,11.72-4.63,12.3-8.39,22-8.39,22s2.57,6.83,15,9.87l5.44-14.11c2.82-6.09,4.6-10,5.21-15.19C156.4,233.78,155.2,228.34,152.93,225.81Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.86,341.79a1.25,1.25,0,0,1-1.25-1.25V260.29a1.25,1.25,0,0,1,2.5,0v80.25A1.25,1.25,0,0,1,278.86,341.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.51,312.58a1.26,1.26,0,0,1-1.16-.79L302.74,249.5a1.25,1.25,0,0,1,2.33-.92l24.6,62.29a1.24,1.24,0,0,1-.7,1.62A1.22,1.22,0,0,1,328.51,312.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.56,305.1a1.26,1.26,0,0,1-.91-.39l-45.79-48.46L233.15,304.5a1.25,1.25,0,1,1-1.81-1.72L278,253.58a1.23,1.23,0,0,1,.9-.39h0a1.25,1.25,0,0,1,.91.39L326.46,303a1.24,1.24,0,0,1,0,1.77A1.26,1.26,0,0,1,325.56,305.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.21,312.58a1.25,1.25,0,0,1-1.16-1.71l24.61-62.29a1.25,1.25,0,1,1,2.32.92l-24.61,62.29A1.24,1.24,0,0,1,229.21,312.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.82,303.17l3.25,8.59a.83.83,0,0,1,0,.22.38.38,0,0,1,0,.15,1,1,0,0,1-.49.55,2.22,2.22,0,0,1-2,0,.89.89,0,0,1-.39-.41h0l0-.12-3-8.05Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.91,303.17l-3.26,8.59a.83.83,0,0,0,0,.22v.15a1,1,0,0,0,.49.55,2.22,2.22,0,0,0,2,0,.89.89,0,0,0,.39-.41h0l0-.12,3-8.05Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.3,334.33v7.1a.73.73,0,0,1-.42.59,2.29,2.29,0,0,1-2,0,.73.73,0,0,1-.42-.59v-7.1A3.06,3.06,0,0,1,280.3,334.33Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.85,252.42c0-1.88-1.66-3.88-5.14-6.15-6.44-4.17-20.83-12.56-29.84-17.56a.11.11,0,0,0-.08-.07c-6.93-4.21-13.4-24.25-18.2-39.48-1.64-5.19-3.64-8.13-6-9.51-.56-.33-2.64-1.47-3.1-1.75-4.71-2.82-10.89.57-18.59,4.78-7.1,3.88-12.64,8.85-13.75,22-.68,8,0,23.37,1.6,35h0c2.36,19.42,5.26,19.46,9.47,22.71,7.24,5.59,23.55,13.46,30.42,16.16,12.47,4.9,22.65-2.66,30.25-6.41A177.39,177.39,0,0,0,323,260.25c1.9-1.38,2.88-2.77,2.86-4.24C325.83,255.42,325.85,253,325.85,252.42Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.85,252.42c0-1.88-1.66-3.88-5.14-6.15-6.44-4.17-20.83-12.56-29.84-17.56a.11.11,0,0,0-.08-.07c-6.93-4.21-13.4-24.25-18.2-39.48-1.64-5.19-3.64-8.13-6-9.51-.56-.33-2.64-1.47-3.1-1.75-4.71-2.82-10.89.57-18.59,4.78-7.1,3.88-12.64,8.85-13.75,22-.68,8,0,23.37,1.6,35h0c2.36,19.42,5.26,19.46,9.47,22.71,7.24,5.59,23.55,13.46,30.42,16.16,12.47,4.9,22.65-2.66,30.25-6.41A177.39,177.39,0,0,0,323,260.25c1.9-1.38,2.88-2.77,2.86-4.24C325.83,255.42,325.85,253,325.85,252.42Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.3,179.49c-4.67-2.45-10.73.88-18.23,5-4.81,2.64-8.9,5.76-11.39,11.6l-3.17-1.83c2.49-5.82,6.58-8.94,11.36-11.57,7.71-4.22,13.89-7.6,18.6-4.78Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.71,246.27c-4.18-2.71-4.27-3.4-30-17.69l.12,0c-6.93-4.22-13.39-24.25-18.19-39.47-4.88-15.47-13-11-24.53-4.68-7.09,3.89-12.63,8.86-13.75,22s1.33,45.88,5.82,49.83c4.91,5.43,24.61,15.52,32.48,18.62,12.47,4.9,22.65-2.66,30.25-6.41A177.39,177.39,0,0,0,323,256.64C327.3,253.5,326.9,250.29,320.71,246.27Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.78,228.63h0Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M248.06,184.48c11.53-6.3,19.65-10.79,24.53,4.68,4.8,15.23,11.27,35.27,18.2,39.48,0,0-11.89,0-29.13,9.3-17.92,9.68-20.65,19.14-21.48,18.46-4.53-3.76-7-36.69-5.87-49.88S241,188.37,248.06,184.48Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Legs--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303,303.23c-.9.69-1.94,1.5-2,2.54a10.54,10.54,0,0,0,1.87,6.26c1.78,2.67,2.5,7.33,2.43,10.4s-1,10.81,2.35,14.43,12.38,6.59,13.26,1S314.11,309,314.11,309Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.6,307.64a84.59,84.59,0,0,1,1.86,12.63c.24,4.64,1.08,8,3.18,9.59s5.57,1.88,4.76-1.37S314.11,309,314.11,309Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.77,226.94c12.93,8.75,13.14,8.45,24.2,16.81,8.12,6.15,15.82,12.12,17,16.23,1.23,4.35-.75,13.93-3.17,23.07s-7.07,25.51-7.07,25.51l-19.88-43-23.39-21.31Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.77,226.94c12.93,8.75,13.14,8.45,24.2,16.81,8.12,6.15,15.82,12.12,17,16.23,1.23,4.35-.75,13.93-3.17,23.07s-7.07,25.51-7.07,25.51l-19.88-43-23.39-21.31Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.21,272.6c-1.63-6.36-6.6-11.2-11.33-15.25-3.76-3.23-11.17-9.25-14.88-12.25a28.53,28.53,0,0,0,2.45-7.54c-2,3.22-4.06,5.94-6,7.33l22.52,23.26,13.18,35.63S318.85,279,317.21,272.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.38,338c-.82.38-1,2.25-1.15,3.62s-1.4,3,.25,5.41,4.95,3.12,7.19,6.4,5.56,9.22,12.91,10.76,12.95-.9,14.31-3.09.13-4.26-4.57-6.94c-5-2.83-6.42-3.67-6.42-3.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.24,322.9s3.59,9.81,5.76,14.31A51.37,51.37,0,0,0,342.38,350c.82.86,2.69,2.46,3.36,3.16a1.41,1.41,0,0,1,0,2.18c-1.52,1.61-8.27,2.3-12.2-.36s-7.92-7.88-10.3-10.05c-1.19-1.09-2.3-2.14-3.12-2.91a3.06,3.06,0,0,1-.91-2.88c.07-.3.14-.65.21-1.06.42-2.21-2.91-11-2.91-11Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.82,226.06c.22,8-4,20-1.25,26.15,3.27,7.19,7.52,10.32,18.13,15.82,8.77,4.56,21.7,11.13,24.31,12.13s2.95,2.54,2.82,7.43,1.95,12.76,7.85,22.46a234.92,234.92,0,0,1,11.58,22.21s7.56,1.18,11.24-3.4c0,0-13.29-52.92-15.77-59.17S286.33,244,286.33,244s2.06-10.2,3.59-17.62Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.82,226.06c.22,8-4,20-1.25,26.15,3.27,7.19,7.52,10.32,18.13,15.82,8.77,4.56,21.7,11.13,24.31,12.13s2.95,2.54,2.82,7.43,1.95,12.76,7.85,22.46a234.92,234.92,0,0,1,11.58,22.21s7.56,1.18,11.24-3.4c0,0-13.29-52.92-15.77-59.17S286.33,244,286.33,244s2.06-10.2,3.59-17.62Z",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.07,179.48c6-.32,8.17-.47,13.19,3.53,1.66,1.32,15.18,13.5,20.61,18,1.52-9.15,3-17.88,3-19.25.18-3.69-.66-5.77-.49-9.57a28.54,28.54,0,0,0-.28-6.28c-.18-1.42,1.34-1,2-.54a6.41,6.41,0,0,1,2.43,2.82c.45,1,.82,2.36,1.92,2.58.91.19,1.73-.55,2.35-1.24a52.2,52.2,0,0,0,6.2-8.42,5.11,5.11,0,0,1,1-1.39,1.47,1.47,0,0,1,2.55,1,5.19,5.19,0,0,1-.21,1.7,3,3,0,0,1,2.22,1.84c.3.65.36,1.35.67,2a6,6,0,0,1,.7,2.3,6.47,6.47,0,0,1-.93,3.14,32.45,32.45,0,0,1-3.86,5.77c-1,1.16-1.94,2.35-2.89,3.54a13.14,13.14,0,0,0-2.4,3.5,31.14,31.14,0,0,0-1.2,7.62c-.37,3.94.74,14.54-1.53,23.11-1.31,4.93-4.16,6.63-9.76,3.68-2.71-1.44-26.3-18.38-26.3-18.38S279.87,189.21,279.07,179.48Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.87,201c-.94,2.55-.26,9.86.78,11.92a18.31,18.31,0,0,1-2-13Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chest--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.22,181.8l-10.8,2.85s4.56,7.65,3.34,15c-1.31,8-2.13,8.69-4.75,10.68,1.17,4.69,3.43,15.5,3.43,15.5A57.71,57.71,0,0,0,251.61,243s7.54,4.41,25.25.46C292.41,240,293,228.3,293,228.3l-3.5-3.11L289,210.82s7.86-6.7,3.87-15.38-13.83-16-13.83-16l-6.46.54Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.22,181.8l-10.8,2.85s4.56,7.65,3.34,15c-1.31,8-2.13,8.69-4.75,10.68,1.17,4.69,3.43,15.5,3.43,15.5A57.71,57.71,0,0,0,251.61,243s7.54,4.41,25.25.46C292.41,240,293,228.3,293,228.3l-3.5-3.11L289,210.82s7.86-6.7,3.87-15.38-13.83-16-13.83-16l-6.46.54Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.11,210.31a11.62,11.62,0,0,1-10.74,4.56c-7.49-.84-8.77-5.84-8.77-5.84s1.31,7.3,8.87,7.69C279,217.21,280.11,210.31,280.11,210.31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.55,153.45c-.42-11-8.37-17-17.37-18.38h0c-7-1.32-9.69.8-16.73.32-2.9-.19-5.53-.23-7.42.82-2.15,1.19-3.34,3.65-2.93,6.76a6.84,6.84,0,0,0,2.26,4.25c-1.88,3.23.37,8.39,5.13,9.38l5.39,15.67s20.95,7.26,20.81,3.65C278.3,168.6,286,166,285.55,153.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.76,134.73l-.81,5.5A2.76,2.76,0,0,0,282.2,138,2.92,2.92,0,0,0,279.76,134.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,139.08l-5.6.82a2.73,2.73,0,0,0,3.13,2.41A2.93,2.93,0,0,0,285,139.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.94,182.08l-.61-15.93s2.13,2,5-.35c2.62-2.08,3.58-6.35,1.61-8.46-1.39-1.5-5.56-2.19-7.05,1.2,0,0-4.8,0-11.22-4.25s-8.06-8.06-11.91-8.35c-1.75,1.44-3.35,5.55-2.75,16.22.44,7.9,4.12,11.53,6,12.82,1.52,1.05,3.4,1.13,6.57.49l.28,7.48s6.81,10.22,14.38,9.47C286.65,191.28,274.94,182.08,274.94,182.08Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.9,157.81l.17,4.37h0a3.1,3.1,0,0,1-3.24-2.94l-.16-4.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.24,158.92a1.45,1.45,0,0,0,1.42,1.48,1.47,1.47,0,1,0-1.42-1.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.52,155.31l2.9-2.17a1.77,1.77,0,0,0-2.51-.38A1.85,1.85,0,0,0,249.52,155.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.25,166.3l-4.05,2a2.23,2.23,0,0,0,3,1A2.31,2.31,0,0,0,263.25,166.3Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.17,158.41a1.45,1.45,0,1,0,2.89,0,1.44,1.44,0,0,0-1.42-1.48A1.48,1.48,0,0,0,251.17,158.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.56 157.4 258.65 165.16 254.45 164.05 258.56 157.4",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.6,175.47c3.34-.56,10.17-2.77,11.14-5.49a6.87,6.87,0,0,1-2.29,3.51c-2,1.81-8.77,4-8.77,4Z",
    style: {
      fill: "#9a4a4d"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "415.06 370.16 417.33 368.85 417.33 279.21 415.06 277.95 415.06 370.16",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.06 370.16 412.8 368.81 412.8 279.17 415.06 280.52 415.06 370.16",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.2 321.11 332.46 319.85 332.46 230.21 330.2 231.47 330.2 321.11",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.2 321.11 327.93 319.85 327.93 230.21 330.2 231.47 330.2 321.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.93 235.09 415.06 285.23 415.06 277.95 327.93 227.64 327.93 235.09",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "330.07 256.09 414.94 305.15 414.95 302.62 330.07 253.57 330.07 256.09",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "412.8 301.38 330.2 253.64 330.2 251.08 412.8 298.76",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.33 284.61 247.72 382.22 247.72 374.62 417.33 276.82 417.33 284.61",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.72 466.84 249.98 465.53 249.98 375.89 247.72 374.63 247.72 466.84",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.72 466.84 245.45 465.49 245.45 375.85 247.72 377.2 247.72 466.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.85 417.8 165.11 416.54 165.11 326.89 162.85 328.15 162.85 417.8",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.85 417.8 160.59 416.54 160.59 326.9 162.85 328.15 162.85 417.8",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.59 331.77 247.72 381.92 247.72 374.63 160.59 324.33 160.59 331.77",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.72 352.78 247.6 401.83 247.6 399.3 162.72 350.25 162.72 352.78",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "245.45 398.06 162.85 350.33 162.85 347.76 245.45 395.45",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.72 374.63 160.59 324.33 330.2 226.52 417.33 276.82 247.72 374.63",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.72 374.63 160.59 324.33 330.2 226.52 417.33 276.82 247.72 374.63",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.76,256.9c-1.15-.69-2.33-1.33-3.55-1.93-5.73-2.83-9.55-4.8-13.52-7s-7.89-4.11-10.77-6.07c-3.73-2.54-3-4.49-1.88-10.71,1.92-11,6.06-25.18,8-32.62,2.67-10.45,5.52-12.84,14.44-14.14,2.57,2.75,5.85,19.88-1.12,27l-6.8,22.15c3.53,2.89,15.59,11,18,12.31s4.85,1.14,7.62,1.29c2.1.12,4.13.69,6.2,1a14.23,14.23,0,0,0,3.13.16c.43,0,.85,0,1.28-.06s.8-.21,1.15,0a.93.93,0,0,1,.33.93,2.7,2.7,0,0,1-1.6,1.69,15.56,15.56,0,0,1-4.73,1.6,2.7,2.7,0,0,0,1.75,1.35,52.35,52.35,0,0,0,9.46,2.59,3.29,3.29,0,0,1,1,.29,1.08,1.08,0,0,1,.61.84,1.28,1.28,0,0,1-.78,1.1,8.34,8.34,0,0,0-1.27.63,6.92,6.92,0,0,0-1,1.21,7.62,7.62,0,0,1-2.68,1.85,15,15,0,0,1-3.68,1.44,13.81,13.81,0,0,1-6-.48,31.69,31.69,0,0,1-5.4-1.8A76.27,76.27,0,0,1,259.76,256.9Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.49,305.45l-30.43-17.56a1.72,1.72,0,0,0-1.75,0l-52.8,30.48a.39.39,0,0,0,0,.68l30.72,17.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.22,301.75v.69a2.79,2.79,0,0,1-1.41,2.43l-49.17,28.39a2.81,2.81,0,0,1-2.82,0L205,317.84a2.84,2.84,0,0,1-1.4-2.44v-.95h0a.33.33,0,0,0,.18.31l29.44,17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.22,301.75l-29.16-16.83a1.66,1.66,0,0,0-1.67,0L203.8,314.13a.37.37,0,0,0,0,.64l29.43,17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-5",
    d: "M210.2,264.38c4.29,2.06,9.7,4.77,12.82,6.17s5.39,2.14,8.89,3.52c2.68,1.06,6,1.87,8.05,3.46s12.41,10.28,14.64,11.74,1.34,3.34-2.47,4.81a11.75,11.75,0,0,1-9.43-.17,38.89,38.89,0,0,1-6.77-4.18,9.83,9.83,0,0,1-5.31-1.3c-2.18-1.49-3.57-3.37-4.83-4.26s-12.81-4.11-21.56-6.63Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.96 329.29 217.24 320.22 263.23 293.67 279.03 302.69 232.96 329.29",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.03 302.69 278.43 303.04 263.22 294.36 217.84 320.57 217.24 320.22 263.22 293.67 279.03 302.69",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.03 302.69 278.43 303.04 263.22 294.36 217.84 320.57 217.24 320.22 263.22 293.67 279.03 302.69",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.23 304.06 225.52 304.23 233.23 308.68 246.94 300.76 247.23 300.6 239.23 295.98 225.23 304.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.52 304.23 233.23 308.68 246.94 300.76 239.23 296.31 225.52 304.23",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.23,331.77v1.87a2.77,2.77,0,0,0,1.41-.38l49.18-28.39a2.8,2.8,0,0,0,1.4-2.43v-.69Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.23,331.77v1.87a2.77,2.77,0,0,0,1.41-.38l49.18-28.39a2.8,2.8,0,0,0,1.4-2.43v-.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,332.18a3.33,3.33,0,0,0,2.87-.22l49-28.27a3.33,3.33,0,0,0,1.62-2.33l5.36-32a3.39,3.39,0,0,0,0-.55,3.34,3.34,0,0,0-1-2.37L241,295.87a2.43,2.43,0,0,0-1.19,1.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.23,331.77l.34.19a2.67,2.67,0,0,0,.45.22l5.8-34.59a2.43,2.43,0,0,1,1.19-1.72l50.89-29.39a3.45,3.45,0,0,0-.68-.51l-51,29.43a2.47,2.47,0,0,0-1.19,1.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.29,296.52l-.79-.46a2.39,2.39,0,0,0-.46,1.07l-5.81,34.64.34.19a2.67,2.67,0,0,0,.45.22l5.8-34.59A2.41,2.41,0,0,1,240.29,296.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.6,302.67c.36-2.14,2.57-5,4.94-6.35s4-.73,3.63,1.41-2.57,5-4.93,6.35S261.24,304.81,261.6,302.67Z",
    style: {
      fill: "#FF577F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coffee--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-5",
    d: "M240.73,355.93c-3.33,1.84-3.33,4.83,0,6.67a13.82,13.82,0,0,0,12,0c3.33-1.84,3.33-4.83,0-6.67A13.82,13.82,0,0,0,240.73,355.93Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.91,345a17.5,17.5,0,0,0-10.6.28c-2.84,1.17-2.8,2.94.11,4A17.46,17.46,0,0,0,252,349C255,347.83,254.92,346.05,251.91,345Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.91,345a17.5,17.5,0,0,0-10.6.28c-2.84,1.17-2.8,2.94.11,4A17.46,17.46,0,0,0,252,349C255,347.83,254.92,346.05,251.91,345Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M254.19,341.37l-15.27.41,1.63,18h0c.09.65.72,1.28,1.9,1.75a13.49,13.49,0,0,0,9.16-.24c1.19-.53,1.81-1.19,1.87-1.85h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.92,341.78l.33,3.64a6.3,6.3,0,0,0,1.3.65,18.46,18.46,0,0,0,12.16-.31,3.73,3.73,0,0,0,.4-.2,7.47,7.47,0,0,0,.94-.56l.14-3.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.17,341.87l-.07-2.75-1.78.05a8.51,8.51,0,0,0-.79-.34,18.55,18.55,0,0,0-12.16.31c-.27.12-.51.25-.74.38l-1.73.05.07,2.75h0c0,.89.87,1.77,2.54,2.41a18.53,18.53,0,0,0,12.16-.32C254.36,343.69,255.2,342.77,255.17,341.87Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.17,341.87l-.07-2.75-1.78.05a8.51,8.51,0,0,0-.79-.34,18.55,18.55,0,0,0-12.16.31c-.27.12-.51.25-.74.38l-1.73.05.07,2.75h0c0,.89.87,1.77,2.54,2.41a18.53,18.53,0,0,0,12.16-.32C254.36,343.69,255.2,342.77,255.17,341.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M252.48,336.71a18.52,18.52,0,0,0-12.17.32c-3.26,1.45-3.21,3.67.13,5a18.53,18.53,0,0,0,12.16-.32C256,340.21,255.93,338,252.48,336.71Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.5,338.5h0l-.61-2.25-4.37.11a18,18,0,0,0-4.34.11l-4.24.11-.49,2.28h0c-.25.84.43,1.68,2,2.27a15.85,15.85,0,0,0,10-.26C253.15,340.2,253.81,339.32,253.5,338.5Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.5,338.5h0l-.61-2.25-4.37.11a18,18,0,0,0-4.34.11l-4.24.11-.49,2.28h0c-.25.84.43,1.68,2,2.27a15.85,15.85,0,0,0,10-.26C253.15,340.2,253.81,339.32,253.5,338.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,334.85a15.3,15.3,0,0,0-9.21.24c-2.47,1-2.43,2.53.09,3.4a15.34,15.34,0,0,0,9.21-.24C253.61,337.25,253.57,335.72,251,334.85Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.05,336.53a.86.86,0,0,1-.28.33,4.67,4.67,0,0,1-1.05.56,13.67,13.67,0,0,1-4.31.77,13,13,0,0,1-4.28-.54,3.61,3.61,0,0,1-1-.52c-.21-.16-.27-.29-.27-.32s.21-.46,1.27-.89a12.71,12.71,0,0,1,4.24-.76,13,13,0,0,1,4.35.54C251.76,336.06,252,336.45,252.05,336.53Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M252.05,336.53a.86.86,0,0,1-.28.33,4.67,4.67,0,0,1-1.05.56,13.67,13.67,0,0,1-4.31.77,13,13,0,0,1-4.28-.54,3.61,3.61,0,0,1-1-.52c-.21-.16-.27-.29-.27-.32s.21-.46,1.27-.89a12.71,12.71,0,0,1,4.24-.76,13,13,0,0,1,4.35.54C251.76,336.06,252,336.45,252.05,336.53Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M251.77,336.86a4.67,4.67,0,0,1-1.05.56,13.67,13.67,0,0,1-4.31.77,13,13,0,0,1-4.28-.54,3.61,3.61,0,0,1-1-.52,3.81,3.81,0,0,1,1-.57,14.61,14.61,0,0,1,8.59-.21A3.89,3.89,0,0,1,251.77,336.86Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M251.77,336.86a4.67,4.67,0,0,1-1.05.56,13.67,13.67,0,0,1-4.31.77,13,13,0,0,1-4.28-.54,3.61,3.61,0,0,1-1-.52,3.81,3.81,0,0,1,1-.57,14.61,14.61,0,0,1,8.59-.21A3.89,3.89,0,0,1,251.77,336.86Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M249.18,337a1.33,1.33,0,0,1,1-.22c.19.1,0,.37-.33.59a1.25,1.25,0,0,1-1,.22C248.66,337.47,248.81,337.2,249.18,337Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M239.81,353.94c0,.67.71,1.33,2.08,1.81a16.48,16.48,0,0,0,10-.25c1.39-.56,2.07-1.25,2.05-1.92l.27-6.62c0,.72-.71,1.46-2.18,2a17.46,17.46,0,0,1-10.6.28c-1.46-.51-2.19-1.21-2.21-1.93Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.48,354.21a9.26,9.26,0,0,1-.62-1.11,3.31,3.31,0,0,0-1.77-1.47.2.2,0,0,0-.26.1,2.59,2.59,0,0,0,3.3,3.18c.05,0,.06-.11,0-.13A2.24,2.24,0,0,1,244.48,354.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.5,351.41a3.5,3.5,0,0,1,1.11.64,3.26,3.26,0,0,1,.81,1.06,3.23,3.23,0,0,0,1,1.28.21.21,0,0,0,.3-.05,2.29,2.29,0,0,0-.61-2.77,2.34,2.34,0,0,0-2.68-.54A.21.21,0,0,0,242.5,351.41Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.68,279.52l17.34,10a2.35,2.35,0,0,0,2.13,0l56-32.32a.65.65,0,0,0,0-1.23l-17.34-10a2.35,2.35,0,0,0-2.13,0l-55.95,32.32A.66.66,0,0,0,295.68,279.52Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.72,276.77v-.38a2.09,2.09,0,0,1,1-1.65l50.11-29a2.08,2.08,0,0,1,1.91,0l15.53,9a2.13,2.13,0,0,1,1,1.66v.38a2.09,2.09,0,0,1-1,1.65l-50.11,29a2.14,2.14,0,0,1-1.91,0l-15.53-9A2.13,2.13,0,0,1,296.72,276.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.68,275.84l15.53,9a2.08,2.08,0,0,0,1.91,0l50.11-28.95a.59.59,0,0,0,0-1.11l-15.53-9a2.08,2.08,0,0,0-1.91,0l-50.11,29A.58.58,0,0,0,297.68,275.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.25,274.71,398.18,273a3.7,3.7,0,0,0-3.48,0l-15.3,8.83-2-1.18a3.44,3.44,0,0,0-3.11,0L355.7,291.4a1,1,0,0,0,0,1.8l2,1.13-22.11,12.76a1.08,1.08,0,0,0,0,2l3.08,1.77a3.88,3.88,0,0,0,3.51,0l22.11-12.77a3.41,3.41,0,0,0,3.11,0l18.51-10.75c.83-.49.85-1.26.06-1.76l15.3-8.83A1.11,1.11,0,0,0,401.25,274.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,262.33l4-48.85a4.62,4.62,0,0,0-2-4,5.13,5.13,0,0,0-4.64.09l-53.5,30.89a5.91,5.91,0,0,0-2.62,4.13l-4,48.86a4.61,4.61,0,0,0,2,4,5.11,5.11,0,0,0,4.63-.09l53.5-30.89A5.88,5.88,0,0,0,392,262.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,262.33l4-48.85a4.61,4.61,0,0,0-2-4,5.11,5.11,0,0,0-4.63.09l-53.5,30.89a5.39,5.39,0,0,0-1.74,1.75l8.32,4.8v46.6l46.92-27.1A5.88,5.88,0,0,0,392,262.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.74,296l4-48.85a5.87,5.87,0,0,1,2.61-4.13l53.51-30.89c1.32-.77,2.29-.15,2.16,1.37l-4,48.85a5.88,5.88,0,0,1-2.62,4.13l-53.5,30.89C334.58,298.12,333.61,297.5,333.74,296Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.35,256.78a9.28,9.28,0,0,1,3.92-6.58c2-1.13,3.37,0,3.17,2.48a9.28,9.28,0,0,1-3.92,6.58C362.56,260.39,361.14,259.28,361.35,256.78Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.61 271.55 375.76 263.91 373.52 262.62 360.38 270.26 362.61 271.55",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.87,286.34l-16,9.25a2.06,2.06,0,0,1-1,.23,2,2,0,0,1-.87-.22h0l-7.05-4.07s0,0,0,0a2.07,2.07,0,0,1-.91-1.63v-.38c0-.6.42-.86.95-.55l4.26,2.45.95.55-.21-1.08-1.5-20.59,2.23,1.3,13.16-7.64,6.85,20.79A1.66,1.66,0,0,1,381.87,286.34Z",
    style: {
      fill: "#37474f"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "356.22 288.86 361.69 285.7 362.8 293.05 356.22 288.86"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M362.61,271.56l-2.23-1.3,1.5,20.59c.12.6-.22.84-.74.53l-4.26-2.45c-.53-.31-.95-.05-.95.55v.38a2.07,2.07,0,0,0,.91,1.63s0,0,0,0l7.05,4.07h0a2,2,0,0,0,.87.22Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.59,323.2c-4.2,2.42-4.2,6.35,0,8.77a16.78,16.78,0,0,0,15.18,0c4.2-2.42,4.2-6.35,0-8.77A16.78,16.78,0,0,0,295.59,323.2Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.86,328.13c3.65-3.73,5.8-13,2.23-16H294c-3.56,2.95-1.42,12.25,2.23,16l.1.1.13.13a3.11,3.11,0,0,0,.33.29l.08.07.28.21a4.66,4.66,0,0,0,.47.3,12.05,12.05,0,0,0,10.88,0h0l.48-.3.25-.2.11-.08.32-.29a.93.93,0,0,0,.14-.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.54,311c-4.13,2.39-4.13,6.26,0,8.64a16.54,16.54,0,0,0,15,0c4.13-2.38,4.13-6.25,0-8.64A16.54,16.54,0,0,0,295.54,311Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.46,312.05c-3.08,1.78-3.08,4.66,0,6.44a12.31,12.31,0,0,0,11.15,0c3.07-1.78,3.07-4.66,0-6.44A12.37,12.37,0,0,0,297.46,312.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.61,315.11a12.31,12.31,0,0,0-11.15,0,5,5,0,0,0-1.85,1.69,5,5,0,0,0,1.85,1.69,12.31,12.31,0,0,0,11.15,0,5.08,5.08,0,0,0,1.84-1.69A5.08,5.08,0,0,0,308.61,315.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.84,301.4v13.69a2.88,2.88,0,0,1-1.7,2.38l-.08,0a7.64,7.64,0,0,1-2.6.84,9.79,9.79,0,0,1-2.86,0,7.64,7.64,0,0,1-2.6-.84l-.08,0a2.88,2.88,0,0,1-1.7-2.38V301.4a5.81,5.81,0,1,1,11.62,0Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,295.58h0a5.6,5.6,0,0,0-4,5.77v16.15l-.08,0a2.88,2.88,0,0,1-1.7-2.38V301.4A5.82,5.82,0,0,1,303,295.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.84,301.4v13.69a2.88,2.88,0,0,1-1.7,2.38l-.08,0V301.36a5.6,5.6,0,0,0-4-5.77h0A5.82,5.82,0,0,1,308.84,301.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M304.46,300.24v18.11a9.79,9.79,0,0,1-2.86,0V300.24a8.43,8.43,0,0,1,1.42-4.65s0,.91,0,.91l0-.91A8.31,8.31,0,0,1,304.46,300.24Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M304.46,318.54a.19.19,0,0,1-.2-.19v-1.56a.2.2,0,0,1,.2-.19.19.19,0,0,1,.19.19v1.56A.18.18,0,0,1,304.46,318.54Zm-2.86-1a.2.2,0,0,1-.19-.2v-1.55a.2.2,0,1,1,.39,0v1.55A.2.2,0,0,1,301.6,317.54Zm2.86-2.1a.2.2,0,0,1-.2-.2v-1.55a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v1.55A.19.19,0,0,1,304.46,315.44Zm-2.86-1a.2.2,0,0,1-.19-.2v-1.55a.2.2,0,1,1,.39,0v1.55A.2.2,0,0,1,301.6,314.43Zm2.86-2.1a.2.2,0,0,1-.2-.2v-1.55a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v1.55A.19.19,0,0,1,304.46,312.33Zm-2.86-1a.2.2,0,0,1-.19-.2v-1.55a.19.19,0,0,1,.19-.19.19.19,0,0,1,.2.19v1.55A.2.2,0,0,1,301.6,311.32Zm2.86-2.1a.2.2,0,0,1-.2-.2v-1.55a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2V309A.19.19,0,0,1,304.46,309.22Zm-2.86-1a.2.2,0,0,1-.19-.19v-1.56a.19.19,0,0,1,.19-.19.19.19,0,0,1,.2.19V308A.2.2,0,0,1,301.6,308.21Zm2.86-2.1a.2.2,0,0,1-.2-.2v-1.55a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v1.55A.19.19,0,0,1,304.46,306.11Zm-2.86-1a.2.2,0,0,1-.19-.19v-1.56a.19.19,0,0,1,.19-.19.19.19,0,0,1,.2.19v1.56A.2.2,0,0,1,301.6,305.1Zm2.86-2.1a.2.2,0,0,1-.2-.2v-1.55a.19.19,0,0,1,.2-.19.18.18,0,0,1,.19.19v1.55A.19.19,0,0,1,304.46,303Zm-2.86-1a.2.2,0,0,1-.19-.19v-1.56a.2.2,0,0,1,.19-.19.2.2,0,0,1,.2.19v1.56A.2.2,0,0,1,301.6,302Zm2.84-2.1a.2.2,0,0,1-.2-.18,7.63,7.63,0,0,0-.26-1.49.21.21,0,0,1,.14-.24.19.19,0,0,1,.24.14,8.35,8.35,0,0,1,.27,1.56.19.19,0,0,1-.18.21Zm-2.69-1h0a.2.2,0,0,1-.16-.23,9.09,9.09,0,0,1,.44-1.52.21.21,0,0,1,.25-.12.2.2,0,0,1,.11.26,9.23,9.23,0,0,0-.42,1.45A.18.18,0,0,1,301.75,298.89Zm1.9-2a.19.19,0,0,1-.18-.11,7.51,7.51,0,0,0-.45-.85.2.2,0,0,1-.25,0,.2.2,0,0,1-.06-.27l.15-.23a.24.24,0,0,1,.16-.07h0a.24.24,0,0,1,.15,0l0,0h0a8.79,8.79,0,0,1,.62,1.13.19.19,0,0,1-.09.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.3,296a.18.18,0,0,1-.17-.11.19.19,0,0,1,.09-.26,4.49,4.49,0,0,1,.75-.27.2.2,0,0,1,.19.33h0a.12.12,0,0,1-.09,0,3.45,3.45,0,0,0-.68.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,315.44a.2.2,0,0,1-.19-.2v-1.47a.2.2,0,1,1,.39,0v1.47A.2.2,0,0,1,299,315.44Zm0-3a.2.2,0,0,1-.19-.19v-1.48a.2.2,0,1,1,.39,0v1.48A.2.2,0,0,1,299,312.48Zm0-3a.19.19,0,0,1-.19-.19v-1.48a.19.19,0,0,1,.19-.19.19.19,0,0,1,.2.19v1.48A.19.19,0,0,1,299,309.52Zm0-2.95a.2.2,0,0,1-.19-.2v-1.48a.2.2,0,0,1,.19-.19.2.2,0,0,1,.2.19v1.48A.2.2,0,0,1,299,306.57Zm0-3a.2.2,0,0,1-.19-.2v-1.47a.2.2,0,1,1,.39,0v1.47A.2.2,0,0,1,299,303.61Zm.05-3h0a.19.19,0,0,1-.17-.21,6.68,6.68,0,0,1,.33-1.48.2.2,0,0,1,.37.13,6.13,6.13,0,0,0-.31,1.39A.2.2,0,0,1,299.05,300.65Zm1-2.75a.2.2,0,0,1-.11,0,.2.2,0,0,1-.05-.27,5.27,5.27,0,0,1,1-1.12.19.19,0,0,1,.27,0,.19.19,0,0,1,0,.28,5,5,0,0,0-1,1A.21.21,0,0,1,300.05,297.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,317.71a.2.2,0,0,1-.19-.2v-.77a.2.2,0,1,1,.39,0v.77A.2.2,0,0,1,299,317.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.75,296h-.08a3.52,3.52,0,0,0-.67-.25.24.24,0,0,1-.11-.06.19.19,0,0,1,.22-.31,3.41,3.41,0,0,1,.72.26.19.19,0,0,1,.1.26A.19.19,0,0,1,303.75,296Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.06,315.44a.2.2,0,0,1-.2-.2v-1.47a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v1.47A.19.19,0,0,1,307.06,315.44Zm0-3a.2.2,0,0,1-.2-.19v-1.48a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v1.48A.19.19,0,0,1,307.06,312.48Zm0-3a.19.19,0,0,1-.2-.19v-1.48a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v1.48A.18.18,0,0,1,307.06,309.52Zm0-3a.19.19,0,0,1-.2-.19v-1.48a.19.19,0,0,1,.2-.19.18.18,0,0,1,.19.19v1.48A.18.18,0,0,1,307.06,306.56Zm0-2.95a.2.2,0,0,1-.2-.2v-1.48a.2.2,0,0,1,.2-.19.19.19,0,0,1,.19.19v1.48A.19.19,0,0,1,307.06,303.61Zm-.05-3a.19.19,0,0,1-.19-.17,6.67,6.67,0,0,0-.32-1.4.2.2,0,0,1,.12-.25.21.21,0,0,1,.25.12,6.94,6.94,0,0,1,.33,1.48.19.19,0,0,1-.17.22Zm-1-2.75a.21.21,0,0,1-.16-.08,5.07,5.07,0,0,0-1-1.05.19.19,0,0,1,0-.27.2.2,0,0,1,.27,0,5.79,5.79,0,0,1,1,1.12.19.19,0,0,1-.05.27A.15.15,0,0,1,306,297.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.06,317.71a.2.2,0,0,1-.2-.2v-.77a.2.2,0,0,1,.2-.2.19.19,0,0,1,.19.2v.77A.19.19,0,0,1,307.06,317.71Z",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Programs--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.08,141.25l-37.62,21.67a2.07,2.07,0,0,0-.93,1.61v21a2,2,0,0,0,.94,1.61l3.71,2.11a2.09,2.09,0,0,0,1.87,0l37.62-21.67a2.08,2.08,0,0,0,.93-1.62V145a2,2,0,0,0-.94-1.61L436,141.24A2.09,2.09,0,0,0,434.08,141.25Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.83,189.34a2.05,2.05,0,0,1-1.65-.09l-3.71-2.11a2,2,0,0,1-.94-1.6v-21a2.05,2.05,0,0,1,.29-1l5.57,3.21a2,2,0,0,0-.27.92v21C401.12,189.21,401.43,189.46,401.83,189.34Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.59,144.79c-.08-.47-.46-.64-.93-.37l-37.61,21.67a1.86,1.86,0,0,0-.66.7l-5.57-3.21a1.85,1.85,0,0,1,.64-.66l37.62-21.67a2.09,2.09,0,0,1,1.87,0l3.71,2.11A2.08,2.08,0,0,1,440.59,144.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.67,144.42l-37.62,21.67a2.07,2.07,0,0,0-.93,1.61v21c0,.6.42.84.93.54l37.62-21.67a2.08,2.08,0,0,0,.93-1.62V145C440.6,144.36,440.18,144.12,439.67,144.42Z",
    style: {
      fill: "#FF577F"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M413.05,165a3.84,3.84,0,0,1,1.4-.53,1.45,1.45,0,0,1,1.06.21,1.92,1.92,0,0,1,.67,1,5.5,5.5,0,0,1,.24,1.78,8.49,8.49,0,0,1-.24,2.06,7.31,7.31,0,0,1-.67,1.75,6.86,6.86,0,0,1-1.06,1.44,6.46,6.46,0,0,1-1.4,1.08l-1.55.9v3.81a.92.92,0,0,1-.1.42.6.6,0,0,1-.23.28l-1.59.92a.18.18,0,0,1-.23,0,.38.38,0,0,1-.1-.3V167.66a.88.88,0,0,1,.1-.41.55.55,0,0,1,.23-.28Zm-1.55,6.75,1.49-.86a2.34,2.34,0,0,0,1.18-2.16c0-.52-.11-.83-.33-.94a.93.93,0,0,0-.85.15l-1.49.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.45,158.39a.17.17,0,0,1,.23,0,.41.41,0,0,1,.09.3v12.08a1,1,0,0,1-.09.41.68.68,0,0,1-.23.28l-1.6.92a.18.18,0,0,1-.23,0,.45.45,0,0,1-.09-.3V167.5l-2.7,1.55v4.58a.92.92,0,0,1-.1.42.6.6,0,0,1-.23.28l-1.59.92a.18.18,0,0,1-.23,0,.42.42,0,0,1-.1-.31V162.85a1,1,0,0,1,.1-.41.61.61,0,0,1,.23-.28l1.59-.92a.17.17,0,0,1,.23,0,.37.37,0,0,1,.1.29v4.51l2.7-1.56V160a1,1,0,0,1,.09-.41.7.7,0,0,1,.23-.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.27,155a4.07,4.07,0,0,1,1.4-.54,1.49,1.49,0,0,1,1.06.22,1.88,1.88,0,0,1,.67,1,5.48,5.48,0,0,1,.24,1.77,8.38,8.38,0,0,1-.24,2.06,7.39,7.39,0,0,1-.67,1.76,6.57,6.57,0,0,1-2.46,2.52l-1.55.9v3.81a.86.86,0,0,1-.1.41.63.63,0,0,1-.23.29l-1.59.91a.17.17,0,0,1-.23,0,.41.41,0,0,1-.1-.3V157.72a1,1,0,0,1,.1-.41.7.7,0,0,1,.23-.29Zm-1.55,6.75,1.49-.86a2.44,2.44,0,0,0,.85-.84,2.49,2.49,0,0,0,.33-1.32c0-.52-.11-.84-.33-.94a1,1,0,0,0-.85.14l-1.49.86Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.08,97.61l-37.62,21.67a2.08,2.08,0,0,0-.93,1.62v21a2,2,0,0,0,.94,1.6l3.71,2.11a2.06,2.06,0,0,0,1.87,0l37.62-21.66a2.09,2.09,0,0,0,.93-1.62v-21a2,2,0,0,0-.94-1.6L436,97.6A2.12,2.12,0,0,0,434.08,97.61Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.83,145.7a2.05,2.05,0,0,1-1.65-.09l-3.71-2.11a2,2,0,0,1-.94-1.6v-21a2.05,2.05,0,0,1,.29-1l5.57,3.21a2,2,0,0,0-.27.92v21C401.12,145.57,401.43,145.82,401.83,145.7Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.59,101.15c-.08-.47-.46-.63-.93-.37l-37.61,21.67a1.94,1.94,0,0,0-.66.7l-5.57-3.2a1.88,1.88,0,0,1,.64-.67l37.62-21.67a2.09,2.09,0,0,1,1.87,0l3.71,2.11A2.1,2.1,0,0,1,440.59,101.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.67,100.78l-37.62,21.67a2.08,2.08,0,0,0-.93,1.62v21c0,.59.42.83.93.53l37.62-21.66a2.09,2.09,0,0,0,.93-1.62v-21C440.6,100.73,440.18,100.49,439.67,100.78Z",
    style: {
      fill: "#FF577F"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M410.59,122.81a.18.18,0,0,1,.23,0,.37.37,0,0,1,.1.29v11.95a.88.88,0,0,1-.1.41.6.6,0,0,1-.23.28l-1.57.91a.18.18,0,0,1-.23,0,.41.41,0,0,1-.1-.3v-4.53L406,133.36v4.53a.88.88,0,0,1-.1.41.55.55,0,0,1-.23.28l-1.57.91a.18.18,0,0,1-.23,0,.4.4,0,0,1-.09-.3v-12a1,1,0,0,1,.09-.41.67.67,0,0,1,.23-.28l1.57-.91a.18.18,0,0,1,.23,0,.38.38,0,0,1,.1.3v4.45l2.66-1.54v-4.45a1,1,0,0,1,.1-.41.67.67,0,0,1,.23-.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.37,117.74a.18.18,0,0,1,.23,0,.38.38,0,0,1,.1.3v2a.85.85,0,0,1-.1.4.55.55,0,0,1-.23.28l-2.11,1.22v9.49a.91.91,0,0,1-.1.41.66.66,0,0,1-.23.28l-1.57.9a.18.18,0,0,1-.23,0,.41.41,0,0,1-.09-.3v-9.48l-2.12,1.22a.17.17,0,0,1-.22,0,.38.38,0,0,1-.1-.3v-2a.85.85,0,0,1,.1-.4.6.6,0,0,1,.22-.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.89,124.24a1,1,0,0,1-.16-.21l-1.13-2.4v6.12a.85.85,0,0,1-.1.4.6.6,0,0,1-.22.28l-1.58.91a.18.18,0,0,1-.23,0,.43.43,0,0,1-.09-.3v-12a1,1,0,0,1,.09-.4.61.61,0,0,1,.23-.28l1.4-.81q.24-.14.36,0a1.1,1.1,0,0,1,.15.2l1.95,4,1.94-6.24c0-.08.08-.21.16-.39a.85.85,0,0,1,.36-.41l1.39-.8a.18.18,0,0,1,.23,0,.38.38,0,0,1,.1.3V124.2a.88.88,0,0,1-.1.41.55.55,0,0,1-.23.28l-1.57.91a.18.18,0,0,1-.23,0,.4.4,0,0,1-.09-.29v-6.12l-1.13,3.7c0,.12-.1.25-.16.4a.75.75,0,0,1-.29.32l-.77.44C425.05,124.3,425,124.3,424.89,124.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.91,117a.17.17,0,0,1,.22,0,.4.4,0,0,1,.1.3v2a.88.88,0,0,1-.1.41.65.65,0,0,1-.22.28l-5.57,3.21a.17.17,0,0,1-.22,0,.37.37,0,0,1-.1-.29v-12a.91.91,0,0,1,.1-.41.65.65,0,0,1,.22-.28l1.58-.9a.17.17,0,0,1,.23,0,.41.41,0,0,1,.09.3v9.48Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.08,54,396.46,75.65a2.06,2.06,0,0,0-.93,1.61v21a2,2,0,0,0,.94,1.61l3.71,2.11a2.09,2.09,0,0,0,1.87,0L439.67,80.3a2.08,2.08,0,0,0,.93-1.62v-21a2,2,0,0,0-.94-1.61L436,54A2.09,2.09,0,0,0,434.08,54Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.83,102.07a2.05,2.05,0,0,1-1.65-.09l-3.71-2.11a2,2,0,0,1-.94-1.6v-21a2.05,2.05,0,0,1,.29-1l5.57,3.21a2,2,0,0,0-.27.92v21C401.12,101.94,401.43,102.19,401.83,102.07Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.59,57.52c-.08-.47-.46-.64-.93-.37L402.05,78.82a1.86,1.86,0,0,0-.66.7l-5.57-3.21a1.85,1.85,0,0,1,.64-.66L434.08,54A2.09,2.09,0,0,1,436,54l3.71,2.11A2.08,2.08,0,0,1,440.59,57.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M439.67,57.15,402.05,78.82a2.07,2.07,0,0,0-.93,1.61v21c0,.6.42.84.93.54L439.67,80.3a2.08,2.08,0,0,0,.93-1.62v-21C440.6,57.09,440.18,56.85,439.67,57.15Z",
    style: {
      fill: "#FF577F"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M410.41,84.2c0,.17,0,.39,0,.68v1.76c0,.29,0,.51,0,.67a5.4,5.4,0,0,0,.11.75,1.16,1.16,0,0,0,.27.53.64.64,0,0,0,.45.21,1.3,1.3,0,0,0,.69-.22,2.83,2.83,0,0,0,.67-.54,3,3,0,0,0,.43-.61,3,3,0,0,0,.26-.62,5.71,5.71,0,0,0,.14-.56,2.22,2.22,0,0,1,.13-.49.63.63,0,0,1,.28-.28l1.57-.91a.15.15,0,0,1,.19,0,.33.33,0,0,1,.07.24,6.7,6.7,0,0,1-.3,2,8.57,8.57,0,0,1-.79,1.9,9.4,9.4,0,0,1-1.18,1.66,6.57,6.57,0,0,1-1.47,1.21,3.19,3.19,0,0,1-1.55.49,1.75,1.75,0,0,1-1.16-.41,2.61,2.61,0,0,1-.74-1.18,6.47,6.47,0,0,1-.29-1.76c0-.49,0-1,0-1.61s0-1.14,0-1.68a10,10,0,0,1,1-4.12,8,8,0,0,1,1.16-1.76,6.16,6.16,0,0,1,1.55-1.29,3.28,3.28,0,0,1,1.47-.49,2,2,0,0,1,1.18.29,2,2,0,0,1,.79,1,3.84,3.84,0,0,1,.3,1.6.78.78,0,0,1-.07.33.57.57,0,0,1-.19.23l-1.57.91c-.14.07-.23.09-.28,0a.76.76,0,0,1-.13-.33,2.49,2.49,0,0,0-.14-.41.82.82,0,0,0-.26-.32.78.78,0,0,0-.43-.11,1.4,1.4,0,0,0-.67.24,2.6,2.6,0,0,0-.69.57,3.48,3.48,0,0,0-.45.74,3.36,3.36,0,0,0-.27.83A8.81,8.81,0,0,0,410.41,84.2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.63,73.19a3.29,3.29,0,0,1,1.42-.47,2,2,0,0,1,1.11.24,1.91,1.91,0,0,1,.73.76,2.47,2.47,0,0,1,.28,1.08.8.8,0,0,1-.08.33.52.52,0,0,1-.18.22l-1.57.91a.47.47,0,0,1-.27.08.41.41,0,0,1-.21-.1l-.11-.12a.82.82,0,0,0-.23-.14.79.79,0,0,0-.36,0,1.54,1.54,0,0,0-.53.2,4.15,4.15,0,0,0-.43.3,3.34,3.34,0,0,0-.38.37,1.89,1.89,0,0,0-.26.44,1.27,1.27,0,0,0-.1.52.59.59,0,0,0,.11.39.54.54,0,0,0,.39.12,3.21,3.21,0,0,0,.71-.1l1.11-.29a3.6,3.6,0,0,1,1.15-.15,1.33,1.33,0,0,1,.82.31,1.62,1.62,0,0,1,.49.83,4.93,4.93,0,0,1,.17,1.41,6.36,6.36,0,0,1-.28,1.84,7.18,7.18,0,0,1-.78,1.72,7.94,7.94,0,0,1-1.17,1.48,7.32,7.32,0,0,1-1.49,1.13,3.59,3.59,0,0,1-1.49.53,2,2,0,0,1-1.15-.21,1.84,1.84,0,0,1-.77-.79,2.74,2.74,0,0,1-.29-1.22.8.8,0,0,1,.08-.33.46.46,0,0,1,.18-.22l1.57-.91a.6.6,0,0,1,.27-.09.46.46,0,0,1,.19.09l.14.15a.9.9,0,0,0,.26.2.84.84,0,0,0,.41.07,1.59,1.59,0,0,0,.6-.22,4.61,4.61,0,0,0,1.07-.83,1.47,1.47,0,0,0,.42-1,.42.42,0,0,0-.15-.38.9.9,0,0,0-.47-.07,4.66,4.66,0,0,0-.8.16l-1.15.29a1.7,1.7,0,0,1-1.8-.32,3.22,3.22,0,0,1-.58-2.21,6.1,6.1,0,0,1,.24-1.65,7.71,7.71,0,0,1,.68-1.67,7.46,7.46,0,0,1,1.07-1.5A6.14,6.14,0,0,1,420.63,73.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.33,68.17a3.21,3.21,0,0,1,1.41-.47,2,2,0,0,1,1.11.24,1.93,1.93,0,0,1,.74.76,2.46,2.46,0,0,1,.27,1.08.67.67,0,0,1-.08.33.51.51,0,0,1-.17.22l-1.57.91a.52.52,0,0,1-.27.08.41.41,0,0,1-.21-.1.66.66,0,0,1-.12-.12.64.64,0,0,0-.22-.14.82.82,0,0,0-.36,0,1.3,1.3,0,0,0-.53.2,4.27,4.27,0,0,0-.44.3,2.53,2.53,0,0,0-.37.36,2,2,0,0,0-.27.44,1.56,1.56,0,0,0-.1.53.54.54,0,0,0,.12.39.49.49,0,0,0,.38.12,2.86,2.86,0,0,0,.72-.11l1.1-.28a3.63,3.63,0,0,1,1.15-.15,1.36,1.36,0,0,1,.83.31,1.69,1.69,0,0,1,.49.83,5,5,0,0,1,.16,1.41,6.35,6.35,0,0,1-.27,1.84,8.05,8.05,0,0,1-.78,1.72,7.6,7.6,0,0,1-1.18,1.48,7,7,0,0,1-1.48,1.13,3.59,3.59,0,0,1-1.49.53,2,2,0,0,1-1.16-.21A1.82,1.82,0,0,1,426,81a2.62,2.62,0,0,1-.29-1.22.8.8,0,0,1,.08-.33.51.51,0,0,1,.17-.22l1.58-.91a.61.61,0,0,1,.26-.09.41.41,0,0,1,.19.09l.15.15a.78.78,0,0,0,.26.2.93.93,0,0,0,.4.07,1.57,1.57,0,0,0,.61-.22,4.82,4.82,0,0,0,1.06-.83,1.44,1.44,0,0,0,.43-1,.4.4,0,0,0-.16-.37.88.88,0,0,0-.47-.07,4.77,4.77,0,0,0-.79.16l-1.15.29a1.74,1.74,0,0,1-1.81-.32,3.28,3.28,0,0,1-.57-2.21,6.1,6.1,0,0,1,.24-1.65,7.67,7.67,0,0,1,.67-1.67,7.93,7.93,0,0,1,1.08-1.5A5.89,5.89,0,0,1,429.33,68.17Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--code-bubble--inject-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.89,37.68V129.5a4.21,4.21,0,0,1-1.91,3.31l-52.75,30.43a1.11,1.11,0,0,1-.63.18,1,1,0,0,1-.24,0l-.16,0-.17-.09a1.54,1.54,0,0,1-.5-.64,2.31,2.31,0,0,1-.2-1V70.29a4.21,4.21,0,0,1,1.9-3.3L363,36.58a1.41,1.41,0,0,1,1.29-.16l.16.09v0a.49.49,0,0,1,.13.12l.05.07a.36.36,0,0,1,.07.1,1.12,1.12,0,0,1,.11.25.42.42,0,0,1,0,.16s0,0,0,0a1,1,0,0,1,0,.18A1.69,1.69,0,0,1,364.89,37.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.27,36.42a1.41,1.41,0,0,0-1.29.16L310.23,67a4.21,4.21,0,0,0-1.9,3.3v6.23l-4.9-2.82V67.51a4.19,4.19,0,0,1,1.9-3.29l52.76-30.41a1.32,1.32,0,0,1,1.38-.11C359.82,33.91,363.86,36.21,364.27,36.42Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.89,37.67c0-1.2-.86-1.69-1.91-1.08L310.23,67a4.21,4.21,0,0,0-1.9,3.3v6.24l56.56-32.6Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363,36.58,310.24,67a3.82,3.82,0,0,0-1.35,1.41L304,65.61a3.82,3.82,0,0,1,1.33-1.4l52.75-30.4a1.32,1.32,0,0,1,1.38-.11c.34.21,4.39,2.5,4.79,2.72A1.39,1.39,0,0,0,363,36.58Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.43,73.71v-6.2a3.92,3.92,0,0,1,.58-1.9l4.89,2.79a3.77,3.77,0,0,0-.57,1.89v6.24Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.07,44.37A2.85,2.85,0,0,0,353,46.65c0,.91.49,1.38,1.08,1a2.82,2.82,0,0,0,1.08-2.28C355.15,44.49,354.67,44,354.07,44.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,42.12a2.85,2.85,0,0,0-1.08,2.28c0,.92.48,1.38,1.08,1A2.85,2.85,0,0,0,359,43.16C359,42.24,358.54,41.78,358,42.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.83,39.88a2.83,2.83,0,0,0-1.08,2.28c0,.92.48,1.38,1.08,1a2.87,2.87,0,0,0,1.07-2.28C362.9,40,362.42,39.54,361.83,39.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,163.25l-.24-.14-4.56-2.62a1.66,1.66,0,0,1-.58-.65,2.34,2.34,0,0,1-.22-1V73.7l4.9,2.82v85.13a2.31,2.31,0,0,0,.2,1A1.7,1.7,0,0,0,309,163.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.1,81.62a.7.7,0,0,1,.1-.36l1.38-2.87.07-.09,0,0a.08.08,0,0,1,.11,0,.18.18,0,0,1,0,.14v1a1.26,1.26,0,0,1,0,.3,1.49,1.49,0,0,1-.1.26L314,81.47l.73.67a.31.31,0,0,1,.1.15.79.79,0,0,1,0,.26v1a.49.49,0,0,1,0,.2.29.29,0,0,1-.11.13l0,0a.11.11,0,0,1-.07,0l-1.38-1.26a.28.28,0,0,1-.1-.25Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.17,74.42a1.9,1.9,0,0,1,.1-.28.56.56,0,0,1,.21-.22l.52-.3a.09.09,0,0,1,.11,0,.18.18,0,0,1,0,.14.49.49,0,0,1,0,.11L316.76,84a1.19,1.19,0,0,1-.1.28.47.47,0,0,1-.21.23l-.5.29a.08.08,0,0,1-.1,0,.16.16,0,0,1-.05-.14.45.45,0,0,1,0-.11Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.85,77.28a.81.81,0,0,1-.1.36l-1.39,2.87a.18.18,0,0,1-.06.08l0,0a.09.09,0,0,1-.11,0,.18.18,0,0,1,0-.14v-1a1.15,1.15,0,0,1,0-.3,1.24,1.24,0,0,1,.1-.26l.73-1.52-.73-.67a.36.36,0,0,1-.1-.15.79.79,0,0,1,0-.26v-1a.43.43,0,0,1,0-.19.3.3,0,0,1,.11-.13l0,0a.07.07,0,0,1,.06,0l1.39,1.27a.31.31,0,0,1,.1.25Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.7,76.62a.1.1,0,0,1,.13,0,.24.24,0,0,1,.06.18v1.06a.53.53,0,0,1-.06.24.36.36,0,0,1-.13.16l-.66.38a.1.1,0,0,1-.13,0,.22.22,0,0,1-.05-.17V77.39a.5.5,0,0,1,.05-.23A.4.4,0,0,1,325,77Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.89,75.35a.1.1,0,0,1,.13,0,.24.24,0,0,1,.06.18V76.6a.49.49,0,0,1-.06.23.4.4,0,0,1-.13.17l-.66.38a.1.1,0,0,1-.13,0,.24.24,0,0,1-.06-.18V76.13a.53.53,0,0,1,.06-.24.36.36,0,0,1,.13-.16Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.07,74.09a.11.11,0,0,1,.14,0,.26.26,0,0,1,.05.17v1.06a.69.69,0,0,1-.05.24.41.41,0,0,1-.14.17l-.65.37a.11.11,0,0,1-.14,0,.25.25,0,0,1,0-.17V74.87a.69.69,0,0,1,0-.24.38.38,0,0,1,.14-.16Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,89.35l32-18.5c.38-.21.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14l-32,18.5c-.38.21-.68.06-.68-.35A1.47,1.47,0,0,1,313.68,89.35Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,101.22l32-18.5c.38-.21.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14l-32,18.5c-.38.21-.68.06-.68-.35A1.47,1.47,0,0,1,324,101.22Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,113.09l15.34-8.85c.38-.21.68-.06.68.35a1.47,1.47,0,0,1-.68,1.14L324,114.58c-.38.21-.68.06-.68-.35A1.47,1.47,0,0,1,324,113.09Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.38,69.32l12.76-7.4c.38-.21.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14L348.38,70.8c-.38.22-.69.07-.69-.34A1.48,1.48,0,0,1,348.38,69.32Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,154.63l32-18.5c.38-.22.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14l-32,18.49c-.38.22-.68.07-.68-.34A1.47,1.47,0,0,1,313.68,154.63Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.38,134.6l12.76-7.4c.38-.22.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14l-12.76,7.39c-.38.22-.69.07-.69-.34A1.48,1.48,0,0,1,348.38,134.6Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.38,116.83l12.76-7.4c.38-.22.69-.06.69.35a1.44,1.44,0,0,1-.69,1.13l-12.76,7.4c-.38.22-.69.06-.69-.35A1.46,1.46,0,0,1,348.38,116.83Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.38,122.76l12.76-7.4c.38-.21.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14l-12.76,7.39c-.38.22-.69.07-.69-.34A1.48,1.48,0,0,1,348.38,122.76Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.49,123.09l7.17-4.14c.38-.22.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14l-7.17,4.14c-.38.22-.68.06-.68-.35A1.47,1.47,0,0,1,337.49,123.09Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,95.3l18.69-10.8c.38-.22.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14L313.68,96.78c-.38.22-.68.07-.68-.34A1.47,1.47,0,0,1,313.68,95.3Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,95.3l18.69-10.8c.38-.22.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14L313.68,96.78c-.38.22-.68.07-.68-.34A1.47,1.47,0,0,1,313.68,95.3Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,101.22,320,97.56c.38-.22.69-.06.69.35A1.46,1.46,0,0,1,320,99l-6.34,3.67c-.38.22-.68.06-.68-.35A1.47,1.47,0,0,1,313.68,101.22Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,101.22,320,97.56c.38-.22.69-.06.69.35A1.46,1.46,0,0,1,320,99l-6.34,3.67c-.38.22-.68.06-.68-.35A1.47,1.47,0,0,1,313.68,101.22Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,107.16l6.34-3.67c.38-.21.69-.06.69.35A1.48,1.48,0,0,1,320,105l-6.34,3.66c-.38.22-.68.07-.68-.34A1.47,1.47,0,0,1,313.68,107.16Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,107.16l6.34-3.67c.38-.21.69-.06.69.35A1.48,1.48,0,0,1,320,105l-6.34,3.66c-.38.22-.68.07-.68-.34A1.47,1.47,0,0,1,313.68,107.16Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,113.09l6.34-3.66c.38-.22.69-.06.69.35a1.46,1.46,0,0,1-.69,1.13l-6.34,3.67c-.38.22-.68.06-.68-.35A1.47,1.47,0,0,1,313.68,113.09Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,113.09l6.34-3.66c.38-.22.69-.07.69.34a1.48,1.48,0,0,1-.69,1.14l-6.34,3.67c-.38.21-.68.06-.68-.35A1.47,1.47,0,0,1,313.68,113.09Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,107.16l18.69-10.8c.38-.22.69-.06.69.35a1.44,1.44,0,0,1-.69,1.13L324,108.64c-.38.22-.68.06-.68-.35A1.45,1.45,0,0,1,324,107.16Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.31,94.83l8.12-4.68c.38-.22.69-.06.69.35a1.44,1.44,0,0,1-.69,1.13l-8.12,4.68c-.38.22-.69.06-.69-.35A1.44,1.44,0,0,1,345.31,94.83Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,107.16l18.69-10.8c.38-.22.69-.06.69.35a1.44,1.44,0,0,1-.69,1.13L324,108.64c-.38.22-.68.06-.68-.35A1.45,1.45,0,0,1,324,107.16Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.31,94.83l8.12-4.68c.38-.22.69-.06.69.35a1.44,1.44,0,0,1-.69,1.13l-8.12,4.68c-.38.22-.69.06-.69-.35A1.44,1.44,0,0,1,345.31,94.83Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,119l6.34-3.67c.38-.21.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14l-6.34,3.66c-.38.22-.68.07-.68-.34A1.47,1.47,0,0,1,313.68,119Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,119l6.34-3.67c.38-.21.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14l-6.34,3.66c-.38.22-.68.07-.68-.34A1.47,1.47,0,0,1,313.68,119Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,137.15l6.34-3.67c.38-.22.69-.06.69.35A1.48,1.48,0,0,1,320,135l-6.34,3.66c-.38.22-.68.06-.68-.35A1.45,1.45,0,0,1,313.68,137.15Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,137.15l6.34-3.67c.38-.22.69-.06.69.35A1.48,1.48,0,0,1,320,135l-6.34,3.66c-.38.22-.68.06-.68-.35A1.45,1.45,0,0,1,313.68,137.15Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,143.08l6.34-3.66c.38-.22.69-.07.69.34a1.48,1.48,0,0,1-.69,1.14l-6.34,3.67c-.38.21-.68.06-.68-.35A1.47,1.47,0,0,1,313.68,143.08Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,143.08l6.34-3.66c.38-.22.69-.07.69.34a1.48,1.48,0,0,1-.69,1.14l-6.34,3.66c-.38.22-.68.07-.68-.34A1.47,1.47,0,0,1,313.68,143.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,149l6.34-3.67c.38-.22.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14l-6.34,3.66c-.38.22-.68.06-.68-.35A1.45,1.45,0,0,1,313.68,149Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.68,149l6.34-3.67c.38-.22.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14l-6.34,3.66c-.38.22-.68.06-.68-.35A1.45,1.45,0,0,1,313.68,149Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,83l8.12-4.68c.38-.22.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14L335,84.45c-.38.22-.69.07-.69-.34A1.48,1.48,0,0,1,335,83Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,83l8.12-4.68c.38-.22.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14L335,84.45c-.38.22-.69.07-.69-.34A1.48,1.48,0,0,1,335,83Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.67,114.57l18.69-10.8c.38-.22.69-.06.69.35a1.46,1.46,0,0,1-.69,1.13l-18.69,10.8c-.38.22-.68.06-.68-.35A1.45,1.45,0,0,1,331.67,114.57Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.45,114.3l18.69-10.8c.38-.22.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14l-18.69,10.79c-.37.22-.68.07-.68-.34A1.49,1.49,0,0,1,342.45,114.3Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,102.24l8.12-4.68c.38-.22.69-.06.69.35a1.46,1.46,0,0,1-.69,1.13L353,103.72c-.38.22-.69.06-.69-.35A1.44,1.44,0,0,1,353,102.24Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,125.74l8.12-4.67c.38-.22.69-.07.69.34a1.48,1.48,0,0,1-.69,1.14L353,127.23c-.38.21-.69.06-.69-.35A1.48,1.48,0,0,1,353,125.74Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,95.29l18.69-10.8c.38-.22.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14L324,96.77c-.38.22-.68.07-.68-.34A1.47,1.47,0,0,1,324,95.29Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,95.29l18.69-10.8c.38-.22.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14L324,96.77c-.38.22-.68.07-.68-.34A1.47,1.47,0,0,1,324,95.29Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.31,83l8.12-4.68c.38-.22.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14l-8.12,4.67c-.38.22-.69.07-.69-.34A1.48,1.48,0,0,1,345.31,83Z",
    style: {
      fill: "#FF577F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.31,83l8.12-4.68c.38-.22.69-.06.69.35a1.48,1.48,0,0,1-.69,1.14l-8.12,4.67c-.38.22-.69.07-.69-.34A1.48,1.48,0,0,1,345.31,83Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.46,129.1l-10.72,10.73a1.62,1.62,0,0,0,.21,2.61c.35.22,4,2.26,4.79,2.8a1.57,1.57,0,0,0,1.34.2l9.21-2.36V131.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.29,131.93l-10.72,10.73a1.62,1.62,0,0,0,1.51,2.78l9.21-2.36Z",
    style: {
      fill: "#455a64"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationPairProgramming);
export default __webpack_public_path__ + "static/media/illustration-pair-programming.71fae7161727a13d2c7b8c477c36ca11.svg";
export { ForwardRef as ReactComponent };